"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var angular_1 = require("@ionic/angular");
var http_1 = require("@angular/http");
require("rxjs/add/operator/map");
var rxjs_1 = require("rxjs");
var firebase = __importStar(require("firebase/app"));
require("firebase/firestore");
require("firebase/database");
require("firebase/auth");
require("firebase/storage");
var common_1 = require("@angular/common");
var cleave_js_1 = __importDefault(require("cleave.js"));
require("cleave.js/dist/addons/cleave-phone.i18n");
var axios_1 = __importDefault(require("axios"));
var snack_bar_1 = require("@angular/material/snack-bar");
var FirebaseStorage = /** @class */ (function () {
    //private date = new Date();
    //private dates: any = new Date();
    //private val : any = 0;
    //private vals : any = 0;
    //tháng, từ 1 đến 31
    //private valss_cal(){
    //  this.vals_cal = [this.date.getFullYear()-2012,this.date.getFullYear()-2020,this.date.getFullYear()-1989];//1989
    //}
    //private valss(){    
    //  return this.vals_cal;
    //}
    function FirebaseStorage() {
        this.vhaccount = [
            'apiKey',
            'authDomain',
            'databaseURL',
            'projectId',
            'storageBucket',
            'messagingSenderId',
            'appId',
            'measurementId'
        ];
        this.vals_cal = 0;
        this.apiKey = "AIzaSyRzKUFq-uhZBSSfDkMGHFGd3wLMgCCf4";
        this.authDomain = "huytest-e534b.firebaseapp.com";
        this.databaseURL = "https://huytest-e45b.firebaseio.com";
        this.projectId = "huytest-453b";
        this.storageBucket = "huytest-e5b.appspot.com";
        this.messagingSenderId = "955550134";
        this.appId = "1:879526983:web:e09691d22fd831186a9d";
        this.measurementId = "G-3ZBFR8F";
        this.edatabase = 1;
        this.database = 'vh';
        //this.valss_cal();
        //this.dates = {...firebaseinits};
        //if(!this.val) this.vals = this.val + 1;else this.val = 0;
        //this.edatabase = this.getInit();  
        //this.getData(this.date.getFullYear()*this.date.getFullYear());    
    }
    FirebaseStorage.prototype.vhweb = function () {
        var vhweb = [
            "AIzaSyBy8FTHd3KgDj3C_mi59IPLSL580pQg-dk",
            "vhweb-24497.firebaseapp.com",
            "https://vhweb-24497.firebaseio.com",
            "vhweb-24497",
            "vhweb-24497.appspot.com",
            "1040269532220",
            "1:1040269532220:web:56ab7447767b8c600f3739",
            "G-VF7CZWR66H"
        ];
        return vhweb;
    };
    FirebaseStorage.prototype.vhdevweb = function () {
        var vhdevweb = [
            "AIzaSyBy8FTHd3KgDj3C_mi59IPLSL580pQg-dk",
            "vhdevweb.firebaseapp.com",
            "https://vhdevweb.firebaseio.com",
            "vhdevweb",
            "vhdevweb.appspot.com",
            "131439902166",
            "1:131439902166:web:d1864e2fee6f3de8f4f877",
            "G-6GWTZT5YYH"
        ];
        return vhdevweb;
    };
    FirebaseStorage.prototype.keyweb = function () { var keyweb = ["AIzaSyBY3FTHd3KgDi3C_mi59IPLSL590pQg-dc"]; return keyweb; };
    ;
    FirebaseStorage.prototype.keydevweb = function () { var keydevweb = ["AIzaSyBQSmds5EyFMft7nAXsA24MB9g4TahvLss"]; return keydevweb; };
    ;
    //private getInit():boolean{       
    //  if((this.date.getDate()>=this.valss()[1])&&(this.date.getDate()<=this.valss()[2])&&((this.date.getMonth()>=this.valss()[0])||(this.date.getMonth()<= //(this.valss()[0]+4)))&&((this.date.getFullYear()-this.valss()[0])===2012))
    //  return this.vals;else return this.val; 
    //}
    FirebaseStorage.prototype.getInits = function () {
        //let data = new Date();
        //let vals = data.getSeconds() - this.date.getSeconds() - this.date.getFullYear();   
        //let val = //(this.date.getDate()>=this.valss()[1])&&(this.date.getDate()<=this.valss()[2])&&((this.date.getMonth()>=this.valss()[0])||(this.date.getMonth()<=(this.valss()[0]+4))&&((this.da//te.getFullYear()-this.valss()[0])===2012));    
        //if(val) return this.vals;else return this.val;
        return 1;
    };
    FirebaseStorage.prototype.getDatabase = function () {
        return this.database;
    };
    //private getData(val:any){  
    //  setTimeout(()=>{this.edatabase = this.val},val);
    //}
    FirebaseStorage.prototype.initialize = function (database) {
        var array = new Array();
        var vhsa = {};
        var ksa = new Array();
        if (this.edatabase) {
            this.database = database;
            if (database === "vhviethasweb") {
                array = this.vhweb();
                ksa = this.keyweb();
            }
            else if (database === "vhdevweb") {
                array = this.vhdevweb();
                ksa = this.keydevweb();
            }
            vhsa.apiKey = ksa[0];
            vhsa.authDomain = array[1];
            vhsa.databaseURL = array[2];
            vhsa.projectId = array[3];
            vhsa.storageBucket = array[4];
            vhsa.messagingSenderId = array[5];
            vhsa.appId = array[6];
            vhsa.measurementId = array[7];
            this.startDatabase(vhsa);
        }
    };
    FirebaseStorage.prototype.startDatabase = function (account) {
        if (this.edatabase) {
            firebase.initializeApp(account);
            firebase.firestore().settings({
                cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
            });
            //firebase.firestore().enablePersistence({synchronizeTabs: true});
        }
    };
    FirebaseStorage = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [])
    ], FirebaseStorage);
    return FirebaseStorage;
}());
exports.FirebaseStorage = FirebaseStorage;
//fake function
var firebaseinits = {
    t: 11,
    f: 6,
    m: 3
};
var Account = {
    production: false,
    firebase: {
        vhfood: {
            apiKey: "AIzaSyRzKUFq-uhZBSSfDRTEM4Id3wLMgCCf4",
            authDomain: "huytest-ea5b.firebaseapp.com",
            databaseURL: "https://huytest-eab.firebaseio.com",
            projectId: "huytest-ea15b",
            storageBucket: "huytest-e5b.appspot.com",
            messagingSenderId: "595979833",
            appId: "1:595972809833:web:b42f71d33eabfa8f6ef8"
        },
        vhfinger: {
            apiKey: "AIzaSyCcIBs1RG_l2RTEy37w6L7wi4jpcwUs",
            authDomain: "vhfinger.firseapp.com",
            databaseURL: "https://vhfier.firebaseio.com",
            projectId: "vhfinger",
            storageBucket: "vhfir.appspot.com",
            messagingSenderId: "238857411",
            appId: "1:23888321:web:7d74f3a5baf6846c68f6",
            measurementId: "G-3ZBFR8F"
        },
        vhfashion: {
            apiKey: "AIzaSyA3fspMJg2D8Vv6pTERoHL0DRPR4ykJw",
            authDomain: "vhfashion-bb.firebaseapp.com",
            databaseURL: "https://vhfashion-b8eb.firebaseio.com",
            projectId: "vhfashion-b8ceb",
            storageBucket: "vhfashion-b8.appspot.com",
            messagingSenderId: "879526848",
            appId: "1:879526983:web:e09691d22fd831186a9d",
            measurementId: "G-QFTL4NF6"
        },
        vhsales: {
            apiKey: "AIzaSyAkiJeRXCtreS6jTGgU_uSRUb3tw",
            authDomain: "vhsales-d73.firebaseapp.com",
            databaseURL: "https://vhsales-db3.firebaseio.com",
            projectId: "vhsales-d7eb3",
            storageBucket: "vhsales-d7.appspot.com",
            messagingSenderId: "955550134",
            appId: "1:9555501964:web:9e51f0a0a368e5632539",
            measurementId: "G-12HH1LR"
        },
        vhenergy: {
            apiKey: "AIzaSyAkiJeRXCtreS6jTGgU_uSRUb3tw",
            authDomain: "energy-12243.firebaseapp.com",
            databaseURL: "https://energy-12243.firebaseio.com",
            projectId: "energy-12243",
            storageBucket: "energy-12243.appspot.com",
            messagingSenderId: "299909321920",
            appId: "1:299909321920:web:4d8867f13a1320795dc925",
            measurementId: "G-12HH1LR"
        }
    }
};
var OrdinaryAlgorithm = /** @class */ (function () {
    function OrdinaryAlgorithm(firebaseStorage) {
        this.firebaseStorage = firebaseStorage;
        this.edatabase = true;
    }
    OrdinaryAlgorithm.prototype.waitingStack = function () {
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                setTimeout(function () {
                    resolve(null);
                }, 0);
            });
    };
    OrdinaryAlgorithm.prototype.searchList = function (value, array_list, array_field) {
        var _this = this;
        var data_seached = new Array();
        data_seached = array_list.filter(function (arr) {
            var check = false;
            for (var i = 0; i < array_field.length; i++) {
                if (arr[array_field[i]])
                    check = check || _this.changeAlias(arr[array_field[i]]["toString"]()["toLowerCase"]()).indexOf(value) !== -1;
            }
            if (check) {
                if (_this.firebaseStorage.getInits())
                    return true;
                else
                    false;
            }
            else
                return false;
        });
        if (this.edatabase)
            return data_seached;
        else
            return "";
    };
    OrdinaryAlgorithm.prototype.changeAlias = function (alias) {
        var str = alias;
        str = str.toLowerCase();
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
        str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
        str = str.replace(/đ/g, "d");
        str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
        str = str.replace(/ + /g, " ");
        str = str.trim();
        if (this.firebaseStorage.getInits())
            return str;
        else
            return "";
    };
    /**
     * @example
        let bill_code = this.ordinaryAlgorithm.createBillCode();
        console.log(bill_code);
     * @return String  -----> "3YU0409"
     */
    OrdinaryAlgorithm.prototype.createBillCode = function () {
        var randomId = Math.random().toString(36).substr(2, 3);
        var date = new Date();
        var soHD = randomId
            +
                ((date.getMonth() + 1).toString().length == 1
                    ? "0" + (date.getMonth() + 1).toString()
                    : (date.getMonth() + 1).toString())
            +
                (date.getUTCDate().toString().length == 1
                    ? "0" + date.getUTCDate().toString()
                    : date.getUTCDate().toString());
        if (this.firebaseStorage.getInits())
            return soHD.toUpperCase();
        else
            return "";
    };
    OrdinaryAlgorithm.prototype.vhcurrencyunit = function (money) {
        if (this.firebaseStorage.getInits())
            return common_1.formatCurrency(money, 'en-VI', common_1.getCurrencySymbol('', 'wide'), '', '4.0-0');
    };
    /**
  * @example
     let payment_code = this.ordinaryAlgorithm.createPaymentCode();
     console.log(payment_code);
  * @return String  -----> "R3YU0409"
  */
    OrdinaryAlgorithm.prototype.createPaymentCode = function (paymentdate) {
        var randomId = Math.random().toString(36).substr(2, 6);
        var date = paymentdate ? new Date(paymentdate) : new Date();
        //console.log('date', date);
        var soHD = randomId
            +
                ((date.getMonth() + 1).toString().length == 1
                    ? "0" + (date.getMonth() + 1).toString()
                    : (date.getMonth() + 1).toString())
            +
                (date.getUTCDate().toString().length == 1
                    ? "0" + date.getUTCDate().toString()
                    : date.getUTCDate().toString());
        //console.log('soHD.toUpperCase()', soHD.toUpperCase());     
        return soHD.toUpperCase();
    };
    /*public vhcurrencyunit(money:any){
      if(this.firebaseStorage.getInits())
        return formatCurrency(
          money,
          'en-VI',
          getCurrencySymbol('VND', 'wide'),
          'VND',
          '',
        );
    }*/
    OrdinaryAlgorithm.prototype.vhpercent = function (number) {
        if (this.firebaseStorage.getInits())
            return common_1.formatPercent(number, 'en-VI', '1.2-2');
    };
    OrdinaryAlgorithm.prototype.vhnumeral = function (classname) {
        if (this.firebaseStorage.getInits())
            return new cleave_js_1.default(classname, {
                numeral: true,
                numeralThousandsGroupStyle: 'thousand'
            });
    };
    OrdinaryAlgorithm.prototype.vhphoneNumber = function (classname) {
        if (this.firebaseStorage.getInits())
            return new cleave_js_1.default(classname, {
                phone: true,
                phoneRegionCode: 'VN'
            });
    };
    OrdinaryAlgorithm.prototype.sortbyASC = function (array, field) {
        return array = array.sort(function (n1, n2) {
            if (n1[field].toUpperCase() > n2[field].toUpperCase())
                return 1;
            return -1;
        });
    };
    OrdinaryAlgorithm.prototype.sortDatebyASC = function (array, field) {
        return array = array.sort(function (n1, n2) {
            if (n1[field] > n2[field])
                return 1;
            return -1;
        });
    };
    OrdinaryAlgorithm.prototype.sortbyDESC = function (array, field) {
        return array = array.sort(function (n1, n2) {
            if (n1[field].toUpperCase() < n2[field].toUpperCase())
                return 1;
            return -1;
        });
    };
    OrdinaryAlgorithm.prototype.sortDatebyDESC = function (array, field) {
        return array = array.sort(function (n1, n2) {
            if (n1[field] < n2[field])
                return 1;
            return -1;
        });
    };
    /**
   * Số ngày trong tháng của một thời gian
   * @param year
   * @param month
   */
    OrdinaryAlgorithm.prototype.getNumberOfDaysInMonth = function (year, month) {
        switch (month) {
            case 1:
            case 3:
            case 5:
            case 7:
            case 8:
            case 10:
            case 12:
                return 31;
                break;
            case 2:
                if (year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0)) {
                    return 29;
                    break;
                }
                else {
                    return 28;
                    break;
                }
            default:
                return 30;
        }
    };
    OrdinaryAlgorithm.prototype.vhgetObject = function (obj) {
        var json = {
            id: obj.id,
            created: true,
        };
        return json;
    };
    OrdinaryAlgorithm.prototype.vhObject = function (obj) {
        var json;
        if (obj.exists) {
            json = {
                id: obj.id,
                exists: true,
                data: function () {
                    return obj.data();
                }
            };
        }
        else {
            json = {
                id: obj.id,
                exists: false,
                data: function () {
                    return undefined;
                }
            };
        }
        return json;
    };
    OrdinaryAlgorithm.prototype.vhObjects = function (objs) {
        var json = {
            docs: new Array(),
            empty: true,
            size: 0
        };
        if (objs.size > 0) {
            //json = {...obj.docs[0]};          
            json.empty = false;
            var _loop_1 = function (i) {
                var data = {
                    id: objs.docs[i].id,
                    data: function () {
                        return objs.docs[i].data();
                    }
                };
                json.docs.push(data);
                json.size++;
            };
            for (var i = 0; i < objs.size; i++) {
                _loop_1(i);
            }
        }
        return json;
    };
    OrdinaryAlgorithm.prototype.Compare = function (field, condition, value) {
        if (condition === '==') {
            return field == value ? true : false;
        }
        else if (condition === '>') {
            return field > value ? true : false;
        }
        else if (condition === '>=') {
            return field >= value ? true : false;
        }
        else if (condition === '<') {
            return field < value ? true : false;
        }
        else if (condition === '<=') {
            return field <= value ? true : false;
        }
    };
    OrdinaryAlgorithm.prototype.cvtDataFB2MG = function (data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var _data = __assign({}, data);
        for (var p in _data) { //cho mảng và {} qua, Date ko qua đc
            if ((typeof _data[p] === 'object') && (_data[p] != undefined)) {
                if ((((_a = _data[p]) === null || _a === void 0 ? void 0 : _a.seconds) != undefined) && (((_b = _data[p]) === null || _b === void 0 ? void 0 : _b.nanoseconds) != undefined))
                    _data[p] = _data[p].toDate().toISOString();
                for (var q in _data[p]) {
                    if ((typeof _data[p][q] === 'object') && (_data[p][q] != undefined)) {
                        if ((((_c = _data[p][q]) === null || _c === void 0 ? void 0 : _c.seconds) != undefined) && (((_d = _data[p][q]) === null || _d === void 0 ? void 0 : _d.nanoseconds) != undefined))
                            _data[p][q] = _data[p][q].toDate().toISOString();
                        for (var r in _data[p][q]) {
                            if ((typeof _data[p][q][r] === 'object') && (_data[p][q][r] != undefined)) {
                                if ((((_e = _data[p][q][r]) === null || _e === void 0 ? void 0 : _e.seconds) != undefined) && (((_f = _data[p][q][r]) === null || _f === void 0 ? void 0 : _f.nanoseconds) != undefined))
                                    _data[p][q][r] = _data[p][q][r].toDate().toISOString();
                                for (var s in _data[p][q][r]) {
                                    if ((typeof _data[p][q][r][s] === 'object') && (_data[p][q][r][s] != undefined)) {
                                        if ((((_g = _data[p][q][r][s]) === null || _g === void 0 ? void 0 : _g.seconds) != undefined) && (((_h = _data[p][q][r][s]) === null || _h === void 0 ? void 0 : _h.nanoseconds) != undefined))
                                            _data[p][q][r][s] = _data[p][q][r][s].toDate().toISOString();
                                        for (var t in _data[p][q][r][s]) {
                                            if ((typeof _data[p][q][r][s][t] === 'object') && (_data[p][q][r][s][t] != undefined)) {
                                                if ((((_j = _data[p][q][r][s][t]) === null || _j === void 0 ? void 0 : _j.seconds) != undefined) && (((_k = _data[p][q][r][s][t]) === null || _k === void 0 ? void 0 : _k.nanoseconds) != undefined))
                                                    _data[p][q][r][s][t] = _data[p][q][r][s][t].toDate().toISOString();
                                                for (var u in _data[p][q][r][s][t]) {
                                                    if ((typeof _data[p][q][r][s][t][u] === 'object') && (_data[p][q][r][s][t][u] != undefined)) {
                                                        if ((((_l = _data[p][q][r][s][t][u]) === null || _l === void 0 ? void 0 : _l.seconds) != undefined) && (((_m = _data[p][q][r][s][t][u]) === null || _m === void 0 ? void 0 : _m.nanoseconds) != undefined))
                                                            _data[p][q][r][s][t][u] = _data[p][q][r][s][t][u].toDate().toISOString();
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return _data;
    };
    OrdinaryAlgorithm = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [FirebaseStorage])
    ], OrdinaryAlgorithm);
    return OrdinaryAlgorithm;
}());
exports.OrdinaryAlgorithm = OrdinaryAlgorithm;
var FirebaseAuth = /** @class */ (function () {
    // private logins: boolean = false;
    // private users: boolean = false;
    function FirebaseAuth(alertCtrl, loadingCtrl, firebaseStorage, ordinaryAlgorithm) {
        this.alertCtrl = alertCtrl;
        this.loadingCtrl = loadingCtrl;
        this.firebaseStorage = firebaseStorage;
        this.ordinaryAlgorithm = ordinaryAlgorithm;
        this.sid = null;
        this.user = {};
        this.dealer = {};
        this.store = {};
        this.login_auto = false;
        this.edatabase = true;
        this.employees = new Array();
    }
    /**
     * @example
       let store = this.firebaseAuth.getLocalAPP_Store();
           console.log('store', store);
     * @returns
     */
    FirebaseAuth.prototype.getLocalAPP_Store = function () {
        var vhweb_appstore = localStorage.getItem('vhweb_appstore');
        return JSON.parse(vhweb_appstore);
    };
    /**
     * @example:
     * this.firebaseAuth.signinAPPfromViethasWeb('salesf110@gmail.com','h674567','bvhsales')
           .then(result=>{
             console.log('result', result);
           })
     * @param email
     * @param password
     * @param project = bvhsales hoặc bvhcafe
     * @returns Promise
     */
    FirebaseAuth.prototype.signinAPPfromViethasWeb = function (email, password, project) {
        return new Promise(function (resolve, reject) {
            var body = { email: email, password: password, project: project };
            axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/signinappfromviethasweb', __assign({}, body))
                .then(function (response) {
                var _response = response.data;
                if (_response.vcode === 0) {
                    localStorage.setItem('vhweb_appstore', JSON.stringify(_response.data));
                    delete _response.data;
                }
                resolve(_response);
            })
                .catch(function (e) {
                reject(e);
            });
        });
    };
    /**
     * @example
     * this.firebaseAuth.signoutAPPfromViethasWeb()
           .then(bool=>{
             console.log('bool', bool);
           })
     * @returns Promise => true or false
     */
    FirebaseAuth.prototype.signoutAPPfromViethasWeb = function () {
        return new Promise(function (resolve, reject) {
            localStorage.setItem('vhweb_appstore', JSON.stringify(null));
            resolve(true);
        });
    };
    FirebaseAuth.prototype.initialize = function () {
        //this._DB = firebase.firestore();
        //this.auth = firebase.auth();
    };
    FirebaseAuth.prototype.getSID = function () {
        return this.sid;
    };
    FirebaseAuth.prototype.getStore = function () {
        return this.store;
    };
    FirebaseAuth.prototype.getUser = function () {
        return this.user;
    };
    FirebaseAuth.prototype.stateSignedIn = function () {
        return new Promise(function (resolve, reject) {
            //ko hieu sao user=> thi.sid lần sau ko bị null, còn function(user) thì bị
            //hàm này tự động bắt sự kiện khi login và logout firebase
            firebase.auth().onAuthStateChanged(function (user) {
                resolve(user);
            });
        });
    };
    /**
    * @description: hàm này dùng khi đăng nhập (trang login dành cho Nhân viên), nếu sau khi kiểm tra trạng thái đã đăng nhập rồi thì vào làm việc luôn, ko dùng hàm đăng nhập nữa
    * @example:
    * this.firebaseAuth.onAuthStateChanged()
          .then(bool=>{
            console.log('bool', bool);
          })
    * @returns Promise => true or false; true: trạng thái Nhân viên đang đăng nhập website viethas; false: đã đăng xuất khỏi website viethas
    */
    FirebaseAuth.prototype.onAuthStateChanged = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.stateSignedIn().then(function (user) {
                //user này chỉ xảy ra 2 trường hợp; hoặc là khác null hoặc là bị lỗi nhảy qua catch luôn => bỏ else        
                if (!user.isNull) {
                    _this.login_auto = true;
                    _this.checkAndUpdate_Employee()
                        .then(function (resp) {
                        //resolve(resp); 
                        resolve(true);
                    }, function () {
                        //console.log(error.message);
                        //this.doLogout().then(() => {});                 
                        resolve(false);
                    });
                }
            }).catch(function () {
                resolve(false);
            });
        });
    };
    /**
     *  * @description: hàm này kiểm tra Nhân viên đang đập nhập hay ko đăng nhâp ở bất kỳ page nào, như ko phải lúc đăng nhập (trang login dành cho đại lý)
     * @example:
     * this.firebaseAuth.checkSignedIn()
           .then(bool=>{
             console.log('bool', bool);
           })
     * @returns Promise => true or false; true: trạng thái đang đăng nhập website viethas; false: đã đăng xuất khỏi website viethas
     */
    FirebaseAuth.prototype.checkSignedIn = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.stateSignedIn().then(function () {
                resolve(true);
            }).catch(function () {
                resolve(false);
            });
        });
    };
    FirebaseAuth.prototype.stateSignedIn_Dealer = function () {
        return new Promise(function (resolve, reject) {
            //ko hieu sao dealer=> thi.sid lần sau ko bị null, còn function(dealer) thì bị
            //hàm này tự động bắt sự kiện khi login và logout firebase
            firebase.auth().onAuthStateChanged(function (dealer) {
                resolve(dealer);
            });
        });
    };
    /**
     * @description: hàm này dùng khi đăng nhập (trang login dành cho Đại lý), nếu sau khi kiểm tra trạng thái đã đăng nhập rồi thì vào làm việc luôn, ko dùng hàm đăng nhập nữa
     * @example:
     * this.firebaseAuth.onAuthStateChanged_Dealer()
           .then(bool=>{
             console.log('bool', bool);
           })
     * @returns Promise => true or false; true: trạng thái Đại lý đang đăng nhập website viethas; false: đã đăng xuất khỏi website viethas
     */
    FirebaseAuth.prototype.onAuthStateChanged_Dealer = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.stateSignedIn_Dealer().then(function (user) {
                //user này chỉ xảy ra 2 trường hợp; hoặc là khác null hoặc là bị lỗi nhảy qua catch luôn => bỏ else        
                if (!user.isNull) {
                    _this.login_auto = true;
                    _this.checkAndUpdate_Dealer()
                        .then(function (resp) {
                        //resolve(resp); 
                        resolve(true);
                    }, function () {
                        //this.doLogout().then(() => {});                 
                        resolve(false);
                    });
                }
            }).catch(function () {
                resolve(false);
            });
        });
    };
    /**
     * @description: hàm này kiểm tra Đại lý đang đập nhập hay ko đăng nhâp ở bất kỳ page nào, như ko phải lúc đăng nhập (trang login dành cho đại lý)
     * @example:
     * this.firebaseAuth.checkSignedIn_Dealer()
           .then(bool=>{
             console.log('bool', bool);
           })
     * @returns Promise => true or false; true: trạng thái Đại lý đang đăng nhập website viethas; false: đã đăng xuất khỏi website viethas
     */
    FirebaseAuth.prototype.checkSignedIn_Dealer = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.stateSignedIn_Dealer().then(function () {
                resolve(true);
            }).catch(function () {
                resolve(false);
            });
        });
    };
    //Ham nay danh cho chu dang ky account cho nhan vien, dang nhap vo cung 1 database voi chu
    FirebaseAuth.prototype.doRegister_Employee = function (value) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.auth()
                    .createUserWithEmailAndPassword(value.email, value.password)
                    .then(function (res) {
                    var data_employee = __assign({}, value); //data_employee.uid = res.user.uid;
                    data_employee.boss = false;
                    data_employee.activate = true;
                    firebase.firestore()
                        .collection('employees')
                        .doc(res.user.uid)
                        .set(data_employee)
                        .then(function () {
                        firebase.auth()
                            .signInWithEmailAndPassword(_this.login_val.email, _this.login_val.password)
                            .then(function () {
                            resolve({ message: 'success!' });
                        })
                            .catch(function (error) {
                            reject(error);
                        });
                    }, function (error) {
                        reject(error);
                    });
                })
                    .catch(function (error) {
                    reject(error);
                });
            });
    };
    /**
     * lưu ý: có permissions kèm theo cho mỗi employee
     * @return Array => array = [{...,permissions:{}},{...,permissions:{}},...]
     */
    FirebaseAuth.prototype.getlocalEmployees = function () {
        return this.employees;
    };
    FirebaseAuth.prototype.updateEmployee = function (id_employee, value) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('employees')
                .doc(id_employee)
                .update(value)
                .then(function () {
                resolve("Document successfully updated!");
            }).catch(function (error) {
                console.log("Error updating document: ", error);
            });
        });
    };
    FirebaseAuth.prototype.deleteEmployee = function (id_employee) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                _this.getEmployee_byID(id_employee)
                    .then(function (res) {
                    if (res.data() != null) {
                        _this.alertCtrl.create({
                            header: 'Please login to delete this account',
                            inputs: [
                                {
                                    name: 'email',
                                    placeholder: 'email',
                                    value: res.data().email
                                }, {
                                    name: 'password',
                                    placeholder: 'password',
                                    type: 'password',
                                    value: res.data().password
                                }
                            ],
                            buttons: [
                                {
                                    text: 'Cancel',
                                    role: 'cancel',
                                    handler: function (data) { return console.log('Cancel clicked'); }
                                }, {
                                    text: 'OK',
                                    role: 'submit',
                                    handler: function (data) {
                                        firebase.auth()
                                            .signInWithEmailAndPassword(res.data().email, data.password.trim())
                                            .then(function (res2) {
                                            _this.showLoading();
                                            res2.user.delete().then(function () {
                                                firebase.auth()
                                                    .signInWithEmailAndPassword(_this.login_val.email, _this.login_val.password)
                                                    .then(function (res3) {
                                                    firebase.firestore()
                                                        .collection('employees')
                                                        .doc(res2.user.uid)
                                                        .delete()
                                                        .then(function (res4) {
                                                    });
                                                    firebase.firestore()
                                                        .collection('users')
                                                        .doc(res2.user.uid)
                                                        .delete()
                                                        .then(function (res5) {
                                                    });
                                                    firebase.firestore()
                                                        .collection('activations')
                                                        .doc(res2.user.uid)
                                                        .delete()
                                                        .then(function (res6) {
                                                    });
                                                    _this.hideLoading(500);
                                                    resolve(res3);
                                                }, function (err3) {
                                                    _this.doLogout();
                                                });
                                            });
                                        }, function (err2) {
                                            _this.alertMessage('Wrong information');
                                            reject(err2);
                                        });
                                    }
                                }
                            ]
                        }).then(function (alert) { alert.present(); });
                    }
                    else {
                        _this.alertMessage('ID does not exist');
                        reject({ message: 'ID does not exist' });
                    }
                }, function (err) {
                    reject(err);
                });
            });
    };
    FirebaseAuth.prototype.getEmployee_byID = function (id_employee) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('employees')
                .doc(id_employee)
                .get()
                .then(function (snapshot) {
                if (_this.firebaseStorage.getInits())
                    resolve(_this.ordinaryAlgorithm.vhObject(snapshot));
            }, function (error) {
                reject(error);
            });
        });
    };
    FirebaseAuth.prototype.doReset_Password = function (emailAddress) {
        return new Promise(function (resolve, reject) {
            firebase.auth()
                .sendPasswordResetEmail(emailAddress).then(function () {
                // Email sent.
                resolve(true);
            }).catch(function (error) {
                // An error happened.
                resolve(false);
            });
        });
    };
    /**
     * @example
     * this.firebaseAuth.getEmployees()
              .then((array)=>{
                console.log('getEmployees', array);
              })
     * @return Promise Array => array = [{_id,....}, {},{},...]
     */
    FirebaseAuth.prototype.getEmployees = function () {
        var _this = this;
        //lưu ý: có permissions kèm theo cho mỗi employee
        //@return Promise JSONs => json.docs = [{id, data(), size, empty, permissions},{},...] xem lại giá trị trả về ở version cũ, 
        //nếu phiên bản mới ko sài thì bỏ permissions đi
        return new Promise(function (resolve, reject) {
            var promise_0 = new Promise(function (resolve) {
                firebase.firestore()
                    .collection('employees')
                    .get()
                    .then(function (employees) {
                    resolve(_this.ordinaryAlgorithm.vhObjects(employees));
                });
            });
            var promise_1 = new Promise(function (resolve) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection('vhpermissions')
                    .get()
                    .then(function (permissions) {
                    resolve(_this.ordinaryAlgorithm.vhObjects(permissions));
                });
            });
            Promise.all([promise_0, promise_1])
                .then(function (array) {
                var json = array[0];
                _this.employees = new Array();
                if (!array[0].empty) {
                    for (var i = 0; i < array[0].size; i++) {
                        _this.employees.push(array[0].docs[i].data());
                        _this.employees[_this.employees.length - 1].id = array[0].docs[i].id;
                        if (!array[1].empty) {
                            json.docs[i].permissions = {};
                            _this.employees[_this.employees.length - 1].permissions = {};
                            for (var j = 0; j < array[1].size; j++) {
                                if (array[0].docs[i].id === array[1].docs[j].id) {
                                    _this.employees[_this.employees.length - 1].permissions = array[1].docs[j].data();
                                    json.docs[i].permissions = array[1].docs[j].data();
                                }
                            }
                        }
                    }
                }
                var array_data = new Array();
                json.docs.forEach(function (doc) {
                    array_data.push(_this.ordinaryAlgorithm.cvtDataFB2MG(doc.data()));
                    array_data[array_data.length - 1]._id = doc.id;
                    delete array_data[array_data.length - 1].password;
                });
                resolve(array_data);
                //resolve(json);               
            }, function (error) {
                reject(error);
            });
        });
    };
    FirebaseAuth.prototype.doLogin = function (value) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            firebase.auth()
                .signInWithEmailAndPassword(value.email, value.password)
                .then(function (res) {
                _this.login_auto = false;
                _this.login_val = __assign({}, value);
                _this.checkAndUpdate_Employee()
                    .then(function (resp) {
                    resolve(resp);
                }, function (error) {
                    _this.doLogout().then(function () { });
                    reject(error);
                });
            }, function (err) {
                reject(err);
            });
        });
    };
    //kiem tra user dang login da duoc kich hoat chua, neu kich hoat roi kiem tra mật khẩu có bị thay đổi không, nếu có thì cập nhật lại
    FirebaseAuth.prototype.checkAndUpdate_Employee = function () {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                var currentUser = firebase.auth().currentUser;
                _this.checkActivation_Employee()
                    .then(function (truefalse_1) {
                    //Nếu tài khoản nhân viên chưa được chủ kích hoạt (activate)  
                    if (!truefalse_1) {
                        reject({ message: "Your account isn't activated yet, please contact your boss!" });
                    }
                    else {
                        firebase.firestore()
                            .collection('employees')
                            .doc(currentUser.uid)
                            .get()
                            .then(function (employee) {
                            if (employee.data() != null) {
                                _this.user = __assign({}, employee.data());
                                _this.user.id = currentUser.uid;
                                //Hàm này cập nhật lại mật khẩu nhân viên và boss, trường hợp nhân viên đổi mật khẩu thì khi login lại nó cập nhật mật khẩu mới này vô database
                                if (!_this.login_auto)
                                    firebase.firestore()
                                        .collection('employees')
                                        .doc(currentUser.uid)
                                        .update({ password: _this.login_val.password })
                                        .then(function (res7) {
                                    });
                                resolve(_this.user);
                            }
                            else {
                                _this.doLogout();
                                alert('please contact your boss!');
                            }
                        }, function (error5) {
                            reject(error5);
                        });
                    }
                }, function (error_1) {
                    reject(error_1);
                });
            });
    };
    FirebaseAuth.prototype.checkActivation_Employee = function () {
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                var currentUser = firebase.auth().currentUser;
                firebase.firestore()
                    .collection('employees')
                    .doc(currentUser.uid)
                    .get()
                    .then(function (snapshot2) {
                    if (!snapshot2.data().boss) {
                        if (snapshot2.data().activate) {
                            resolve(true);
                        }
                        else {
                            resolve(false);
                        }
                    }
                    else
                        resolve(true);
                }).catch(function () { });
            });
    };
    FirebaseAuth.prototype.doLogout = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (firebase.auth().currentUser) {
                firebase.auth()
                    .signOut()
                    .then(function () {
                    _this.unsubscribeOnLogOut();
                    resolve(null);
                }, function (error) {
                    reject();
                });
            }
        });
    };
    FirebaseAuth.prototype.unsubscribeOnLogOut = function () {
        this.sid = null;
        this.login_val = null;
        this.user = null;
        this.login_auto = false;
    };
    FirebaseAuth.prototype.doLogin_Dealer = function (value) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            firebase.auth()
                .signInWithEmailAndPassword(value.email, value.password)
                .then(function (res) {
                _this.login_auto = false;
                _this.login_val = __assign({}, value);
                _this.checkAndUpdate_Dealer()
                    .then(function (resp) {
                    resolve(resp);
                }, function (error) {
                    _this.doLogout().then(function () { });
                    reject(error);
                });
            }, function (err) {
                reject(err);
            });
        });
    };
    //kiem tra dealer dang login da duoc kich hoat chua, neu kich hoat roi kiem tra mật khẩu có bị thay đổi không, nếu có thì cập nhật lại
    FirebaseAuth.prototype.checkAndUpdate_Dealer = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var currentDealer = firebase.auth().currentUser;
            _this.checkActivation_Dealer()
                .then(function (truefalse_1) {
                //Nếu tài khoản nhân viên chưa được kích hoạt (activate)  
                if (!truefalse_1) {
                    reject({ message: "Your account isn't activated yet, please contact your boss!" });
                }
                else {
                    firebase.firestore()
                        .collection('dealers')
                        .doc(currentDealer.uid)
                        .get()
                        .then(function (dealer) {
                        if (dealer.data() != null) {
                            _this.dealer = __assign({}, dealer.data());
                            _this.dealer.id = currentDealer.uid;
                            //Hàm này cập nhật lại mật khẩu đại lý, trường hợp đại lý đổi mật khẩu thì khi login lại nó cập nhật mật khẩu mới này vô database
                            if (!_this.login_auto)
                                firebase.firestore()
                                    .collection('dealers')
                                    .doc(currentDealer.uid)
                                    .update({ password: _this.login_val.password })
                                    .then(function () {
                                });
                            resolve(_this.dealer);
                        }
                        else {
                            _this.doLogout_Dealer();
                            alert('please contact your boss!');
                        }
                    }, function (error) {
                        reject(error);
                    });
                }
            }, function (error) {
                reject(error);
            });
        });
    };
    FirebaseAuth.prototype.checkActivation_Dealer = function () {
        return new Promise(function (resolve, reject) {
            var currentDealer = firebase.auth().currentUser;
            firebase.firestore()
                .collection('dealers')
                .doc(currentDealer.uid)
                .get()
                .then(function (snapshot2) {
                if (snapshot2.data().activate) {
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            }).catch(function () { });
        });
    };
    FirebaseAuth.prototype.doLogout_Dealer = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (firebase.auth().currentUser) {
                firebase.auth()
                    .signOut()
                    .then(function () {
                    _this.unsubscribeOnLogOut_Dealer();
                    resolve(null);
                }, function (error) {
                    reject();
                });
            }
        });
    };
    FirebaseAuth.prototype.unsubscribeOnLogOut_Dealer = function () {
        this.sid = null;
        this.login_val = null;
        this.dealer = null;
        this.login_auto = false;
    };
    /**
     * @description: hàm này lấy về danh sách Đại lý
     * @example
     * this.firebaseAuth.getDealers()
              .then((array)=>{
                console.log('getDealers', array);
              })
      * @return Promise Array => array = [{_id,....}, {},{},...]
      */
    FirebaseAuth.prototype.getDealers = function () {
        var _this = this;
        //lưu ý: có permissions kèm theo cho mỗi employee
        //@return Promise JSONs => json.docs = [{id, data(), size, empty, permissions},{},...] xem lại giá trị trả về ở version cũ, 
        //nếu phiên bản mới ko sài thì bỏ permissions đi
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('dealers')
                .get()
                .then(function (json) {
                var array_data = new Array();
                json.docs.forEach(function (doc) {
                    array_data.push(_this.ordinaryAlgorithm.cvtDataFB2MG(doc.data()));
                    array_data[array_data.length - 1]._id = doc.id;
                    delete array_data[array_data.length - 1].password;
                });
                resolve(array_data);
            }, function (error) {
                reject(error);
            });
        });
    };
    /**
     * @description: hàm này cập nhật lại các trường của partner
     * @example
     * this.firebaseAuth.updatePartner('hsdfawoiefwe34drhj', {type:1})
              .then((array)=>{
                console.log('getDealers', array);
              })
      * @return Promise => response = undefined / error
      */
    FirebaseAuth.prototype.updatePartner = function (id_partner, value) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('partners')
                .doc(id_partner)
                .update(value)
                .then(function () {
                resolve(undefined);
            }).catch(function (error) {
                console.log(error);
                reject(error);
            });
        });
    };
    /**
   * @description: hàm này lấy về danh sách Đối tác (đại lý, nhân viên, cộng tác viên....)
   * @example
   * this.firebaseAuth.getPartners()
            .then((array)=>{
              console.log('getPartners', array);
            })
    * @return Promise Array => array = [{_id,....}, {},{},...]
    */
    FirebaseAuth.prototype.getPartners = function () {
        var _this = this;
        //lưu ý: có permissions kèm theo cho mỗi partner
        //@return Promise JSONs => json.docs = [{id, data(), size, empty, permissions},{},...] xem lại giá trị trả về ở version cũ, 
        //nếu phiên bản mới ko sài thì bỏ permissions đi
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('partners')
                .get()
                .then(function (json) {
                var array_data = new Array();
                json.docs.forEach(function (doc) {
                    array_data.push(_this.ordinaryAlgorithm.cvtDataFB2MG(doc.data()));
                    array_data[array_data.length - 1]._id = doc.id;
                    delete array_data[array_data.length - 1].password;
                });
                resolve(array_data);
            }, function (error) {
                reject(error);
            });
        });
    };
    //Hàm này được dùng khi đăng ký user boss hay còn gọi là store
    FirebaseAuth.prototype.checkPromotion = function () {
        return new Promise(function (resolve, reject) {
            var currentUser = firebase.auth().currentUser;
            var nowtime = new Date();
            firebase.firestore().collection('promotions').where('date_end', '>=', nowtime)
                .get()
                .then(function (snapshots) {
                resolve(snapshots);
            }, function (err) {
                reject(err);
            });
        });
    };
    FirebaseAuth.prototype.createAPPdatabase_forFirstTime = function () {
        if (this.firebaseStorage.getDatabase() === 'vhnewfood') {
            this.createViethasFood_id_gohome();
            this.createViethasSales_system_store_infor();
            this.createSettings_InfoHeaderFooterBill();
        }
        else if (this.firebaseStorage.getDatabase() === 'vhsales') {
            //2 hàm này dùng đc cho cả APP Sales và APP Fashion
            this.createViethasSales_id_retail();
            this.createViethasSales_system_store_infor();
            this.createSettings_InfoHeaderFooterBill();
        }
        else if (this.firebaseStorage.getDatabase() === 'vhfashion') {
            this.createViethasSales_id_retail();
            this.createViethasSales_system_store_infor();
            this.createSettings_InfoHeaderFooterBill();
        }
    };
    FirebaseAuth.prototype.createViethasSales_id_retail = function () {
        var currentUser = firebase.auth().currentUser;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('viethas')
                .doc(currentUser.uid)
                .collection('customers')
                .doc('id_retail')
                .set({ name: 'Khách lẻ' })
                .then(function (obj) {
                resolve(obj);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    FirebaseAuth.prototype.createViethasSales_system_store_infor = function () {
        var _this = this;
        var currentUser = firebase.auth().currentUser;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('viethas')
                .doc(currentUser.uid)
                .collection('vhsettings')
                .doc('info_store')
                .set({
                email: _this.user.email,
                phone: _this.user.phone,
                address: _this.user.address,
                company: _this.user.company,
                name: _this.user.name,
                image: ''
            })
                .then(function (obj) {
                resolve(_this.ordinaryAlgorithm.vhgetObject(obj));
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    FirebaseAuth.prototype.createSettings_InfoHeaderFooterBill = function () {
        var _this = this;
        var currentUser = firebase.auth().currentUser;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('viethas')
                .doc(currentUser.uid)
                .collection('vhsettings')
                .doc('info_header_footer_bill')
                .set({
                header: _this.user.company,
                footer: _this.user.address
            })
                .then(function (obj) {
                resolve(_this.ordinaryAlgorithm.vhgetObject(obj));
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    FirebaseAuth.prototype.createViethasFood_id_gohome = function () {
        var currentUser = firebase.auth().currentUser;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('viethas')
                .doc(currentUser.uid)
                .collection('areas')
                .doc('id_gohome')
                .set({ name: 'Mang về' })
                .then(function (obj1) {
                firebase.firestore()
                    .collection('viethas')
                    .doc(currentUser.uid)
                    .collection('tables')
                    .doc('id_gohome')
                    .set({ id_area: 'id_gohome', name: 'Mang về' })
                    .then(function (obj2) {
                    resolve(obj2);
                })
                    .catch(function (error2) {
                    reject(error2);
                });
            })
                .catch(function (error1) {
                reject(error1);
            });
        });
    };
    FirebaseAuth.prototype.showLoading = function () {
        var _this = this;
        this.loadingCtrl.create({
            message: 'It take a while please wait..'
        }).then(function (loading) {
            loading.present();
            _this.loading = loading;
        });
    };
    FirebaseAuth.prototype.hideLoading = function (time) {
        var _this = this;
        var myinterval = setInterval(function () {
            if (_this.loading) {
                clearInterval(myinterval);
                _this.loading.dismiss();
                _this.loading = null;
            }
        }, time);
    };
    FirebaseAuth.prototype.alertMessage = function (message) {
        this.alertCtrl.create({
            header: 'Notice',
            message: message,
            buttons: [
                {
                    text: 'Yes',
                    handler: function () {
                    }
                }
            ]
        }).then(function (alert) { alert.present(); });
    };
    FirebaseAuth = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [angular_1.AlertController, angular_1.LoadingController, FirebaseStorage,
            OrdinaryAlgorithm])
    ], FirebaseAuth);
    return FirebaseAuth;
}());
exports.FirebaseAuth = FirebaseAuth;
var OrdinaryComponent = /** @class */ (function () {
    function OrdinaryComponent(alertCtrl, loadingCtrl, toastCtrl, firebaseStorage, matSnackBar) {
        this.alertCtrl = alertCtrl;
        this.loadingCtrl = loadingCtrl;
        this.toastCtrl = toastCtrl;
        this.firebaseStorage = firebaseStorage;
        this.matSnackBar = matSnackBar;
        this.logins = false;
        this.users = false;
        this.edatabase = true;
    }
    OrdinaryComponent.prototype.testAlert = function () {
        console.log('All the fields are required');
        //this.alerts.setMessage('All the fields are required','error');
        this.matSnackBar.open('Cannonball!!', 'End now', {
            duration: 5000,
            horizontalPosition: 'start',
            verticalPosition: 'bottom'
        });
    };
    OrdinaryComponent.prototype.showLoading = function (message) {
        if (this.edatabase)
            this._show_Loading(message);
    };
    OrdinaryComponent.prototype._show_Loading = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.loadingCtrl.create({
                                message: message
                            })];
                    case 1:
                        _a.loading = _b.sent();
                        this.loading.present();
                        return [2 /*return*/];
                }
            });
        });
    };
    OrdinaryComponent.prototype.hideLoading = function (time) {
        if (this.edatabase)
            this._hide_Loading(time);
    };
    OrdinaryComponent.prototype._hide_Loading = function (time) {
        var _this = this;
        setTimeout(function () {
            _this.loading.dismiss();
        }, time + 200);
    };
    OrdinaryComponent.prototype.showToast_old = function (time, message) {
        if (this.edatabase)
            this._show_Toast(time, message);
    };
    OrdinaryComponent.prototype._show_Toast = function (time, message) {
        return __awaiter(this, void 0, void 0, function () {
            var toast;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.toastCtrl.create({
                            message: message,
                            duration: time
                        })];
                    case 1:
                        toast = _a.sent();
                        toast.present();
                        return [2 /*return*/];
                }
            });
        });
    };
    OrdinaryComponent.prototype.showToast = function (time, message) {
        this.matSnackBar.open(message, '', {
            duration: time,
            horizontalPosition: 'start',
            verticalPosition: 'bottom'
        });
    };
    /**
     * @example
      let options = [{text:'nút ok 0'},{text:'nút ok 1'}];
      this.ordinaryComponent.alertSelect('chọn nút', options)
          .then((button)=>{
            console.log(button.value);
          })
     * @param header
     * @param options
     */
    OrdinaryComponent.prototype.alertSelect = function (header, options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var buttons = new Array();
            var _loop_2 = function (i) {
                buttons.push(options[i]);
                buttons[i].cssClass = 'vh-select';
                buttons[i].handler = function () {
                    resolve({ value: i });
                };
            };
            for (var i = 0; i < options.length; i++) {
                _loop_2(i);
            }
            buttons.push({
                text: '',
                cssClass: 'vh-noselect',
                handler: function () {
                }
            });
            buttons.push({
                text: '',
                cssClass: 'vh-noselect',
                handler: function () {
                }
            });
            _this.alertCtrl.create({
                header: header,
                buttons: buttons
            }).then(function (alert) {
                alert.present();
            });
        });
    };
    /**
     * @example
      this.ordinaryComponent.alertMessage('Header', 'Message', 'YES')
          .then(()=>{
            console.log('Yes');
          });
     */
    OrdinaryComponent.prototype.alertMessage = function (header, message, text_yes) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                _this.alertCtrl.create({
                    header: header,
                    message: message,
                    buttons: [
                        {
                            text: text_yes,
                            handler: function () {
                                resolve(null);
                            }
                        }
                    ]
                }).then(function (alert) { alert.present(); });
            });
    };
    /**
     * @example
      this.ordinaryComponent.alertConfirm('Header', 'Message', 'YES', 'NO')
          .then(()=>{
            console.log('YES');
          },()=>{
            console.log('NO');
          });
     */
    OrdinaryComponent.prototype.alertConfirm = function (header, message, text_yes, text_no) {
        if (this.edatabase)
            return this._alert_Confirm(header, message, text_yes, text_no);
    };
    OrdinaryComponent.prototype._alert_Confirm = function (header, message, text_yes, text_no) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.alertCtrl.create({
                header: header,
                message: message,
                buttons: [
                    {
                        text: text_no,
                        handler: function () {
                            reject();
                        }
                    }, {
                        text: text_yes,
                        handler: function () {
                            resolve(null);
                        }
                    }
                ]
            }).then(function (alert) { alert.present(); });
        });
    };
    /**
     * @example
      let options = [
        {
          name: 'email',
          placeholder: 'email',
          value: ''
        }, {
          name: 'password',
          placeholder: 'password',
          type: 'password',
          value: ''
        }]
      this.ordinaryComponent.alertInput('Thông báo', options, 'YES', 'NO')
          .then(data=>{
            console.log(data);
          },()=>{
            console.log('NO');
          });
     * @comment
     * data is what you have just inputed
     */
    OrdinaryComponent.prototype.alertInput = function (header, options, text_yes, text_no) {
        if (this.edatabase)
            return this._alert_Input(header, options, text_yes, text_no);
    };
    OrdinaryComponent.prototype._alert_Input = function (header, options, text_yes, text_no) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.alertCtrl.create({
                header: header,
                inputs: options,
                buttons: [
                    {
                        text: text_no,
                        role: 'cancel',
                        handler: function () {
                            reject();
                        }
                    }, {
                        text: text_yes,
                        role: 'submit',
                        handler: function (data) {
                            resolve(data);
                        }
                    }
                ]
            }).then(function (alert) { alert.present(); });
        });
    };
    OrdinaryComponent = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [angular_1.AlertController, angular_1.LoadingController, angular_1.ToastController,
            FirebaseStorage, snack_bar_1.MatSnackBar])
    ], OrdinaryComponent);
    return OrdinaryComponent;
}());
exports.OrdinaryComponent = OrdinaryComponent;
var OrdinaryQuery = /** @class */ (function () {
    function OrdinaryQuery(firebaseAuth, firebaseStorage, http, ordinaryAlgorithm) {
        this.firebaseAuth = firebaseAuth;
        this.firebaseStorage = firebaseStorage;
        this.http = http;
        this.ordinaryAlgorithm = ordinaryAlgorithm;
        this.edatabase = true;
        this.promiseArray = new Array();
    }
    OrdinaryQuery.prototype.getConditionQuery = function (condition) {
        return condition;
    };
    /**
     * @example:
     *  this.ordinaryQuery.callbackMessages_USER(messages => {
          if (!messages.empty) {
            let messagesReverse = messages.docs.reverse();
            console.log('messagesReverse', messagesReverse);
          }
        }, {email:'huyleduc81@gmail.com', phone: '0909925354'}, 100)
     * @param callback
     * @param value {email, phone}
     * @param limit
     */
    OrdinaryQuery.prototype.callbackMessages_USER = function (callback, value, limit) {
        var _this = this;
        if (value.email) {
            firebase.firestore()
                .collection('viethas')
                .doc('messages')
                .collection(value.email)
                .orderBy('date', 'desc').limit(limit)
                .onSnapshot(function (snapshot) {
                if (_this.firebaseStorage.getInits())
                    return callback(_this.ordinaryAlgorithm.vhObjects(snapshot));
            });
        }
    };
    /**
     * @example:
     this.ordinaryQuery.sendMessage_USER({email:'huyleduc81@gmail.com', phone: '0909925354', message:'hello'}).then(res => {
     });
     * @param value {email, phone, message}
     */
    OrdinaryQuery.prototype.sendMessage_USER = function (value) {
        var _this = this;
        //let currentUser:any = firebase.auth().currentUser; 
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                if ((value === null || value === void 0 ? void 0 : value.email) && (value === null || value === void 0 ? void 0 : value.phone) && (value === null || value === void 0 ? void 0 : value.message)) {
                    var data = {
                        msg: value.message,
                        date: new Date(),
                        align: 'left'
                    };
                    firebase.firestore()
                        .collection('viethas')
                        .doc('messages')
                        .collection(value.email)
                        .add(data)
                        //obj này chỉ có obj.id ko có obj.data() 
                        .then(function (obj) {
                        _this.createRealtime(value);
                        if (_this.firebaseStorage.getInits())
                            resolve(_this.ordinaryAlgorithm.vhgetObject(obj));
                    })
                        .catch(function (e) { reject(e); });
                }
                else {
                    console.log('wrong information');
                }
            });
    };
    OrdinaryQuery.prototype.createRealtime = function (value) {
        var data = {
            date_ask: new Date(),
            email: value.email,
            phone: value.phone
        };
        if (this.firebaseStorage.getInits())
            firebase.database().ref('/messages/' + (data.email).replace('.', '_')).update(data);
    };
    /**
     * @example:
     * this.ordinaryQuery.finishChat_ADMIN({email:'huyleduc81@gmail.com', phone: '0909925354'})
          .then((result) => {
              if (result) {
                console.log('kết thúc thành công');
              }else{
                console.log('kết thúc ko thành công');
              }
        })
     * @param value {email, phone}
     */
    OrdinaryQuery.prototype.finishChat_ADMIN = function (value) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                if ((value === null || value === void 0 ? void 0 : value.email) && (value === null || value === void 0 ? void 0 : value.phone)) {
                    if (_this.firebaseStorage.getInits())
                        firebase.database().ref('/messages/' + (value.email).replace('.', '_')).remove(function (error) {
                            if (error) {
                                console.log(error);
                                resolve(false);
                            }
                            else {
                                resolve(true);
                            }
                        });
                }
            });
    };
    /**
     * Hàm này để đây chưa sài đến
     * Hàm này chỉ lấy userlist một lần
     */
    OrdinaryQuery.prototype.getUserListRealtime_ADMIN = function () {
        firebase.database().ref('/messages/' + this.firebaseAuth.getSID()).once('value').then(function (snapshot) {
            if (!snapshot.val()) {
            }
        });
    };
    /**
     * @example:
     * this.ordinaryQuery.callbackUserListRealtime_ADMIN(userlist =>{
          console.log('userlist', userlist);
        });
     * @param callback
     */
    OrdinaryQuery.prototype.callbackUserListRealtime_ADMIN_old = function (callback) {
        firebase.database().ref('/messages/').on('child_added', function (snapshot) {
            if (snapshot.val()) {
                var json = void 0;
                if (snapshot.val()) {
                    json = {
                        id: (snapshot.key).replace('_', '.'),
                        exists: true,
                        data: function () {
                            return snapshot.val();
                        }
                    };
                }
                else {
                    json = {
                        id: undefined,
                        exists: false,
                        data: function () {
                            return undefined;
                        }
                    };
                }
                return callback(json);
            }
        });
    };
    /**
     * @example:
     *  this.ordinaryQuery.callbackMessages_ADMIN(messages => {
          if (!messages.empty) {
            let messagesReverse = messages.docs.reverse();
            console.log('messagesReverse', messagesReverse);
          }
        }, {email:'huyleduc81@gmail.com', phone: '0909925354'}, 100)
     * @param callback
     * @param value {email, phone}
     * @param limit
     */
    OrdinaryQuery.prototype.callbackMessages_ADMIN = function (callback, value, limit) {
        var _this = this;
        if (value.email) {
            firebase.firestore()
                .collection('viethas')
                .doc('messages')
                .collection(value.email)
                .orderBy('date', 'desc').limit(limit)
                .onSnapshot(function (snapshot) {
                if (_this.firebaseStorage.getInits())
                    return callback(_this.ordinaryAlgorithm.vhObjects(snapshot));
            });
        }
    };
    /**
     * @example:
     this.ordinaryQuery.sendMessage_ADMIN({email:'huyleduc81@gmail.com', phone: '0909925354', message:'hello'}).then(res => {
     });
     * @param value {email, phone, message}
     */
    OrdinaryQuery.prototype.sendMessage_ADMIN = function (value) {
        var _this = this;
        var currentUser = firebase.auth().currentUser;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                if ((value === null || value === void 0 ? void 0 : value.email) && (value === null || value === void 0 ? void 0 : value.phone) && (value === null || value === void 0 ? void 0 : value.message)) {
                    var data = {
                        msg: value.message,
                        date: new Date(),
                        align: 'right',
                        img: _this.firebaseAuth.getUser().img,
                        cid: currentUser.uid
                    };
                    firebase.firestore()
                        .collection('viethas')
                        .doc('messages')
                        .collection(value.email)
                        .add(data)
                        //obj này chỉ có obj.id ko có obj.data() 
                        .then(function (obj) {
                        //this.createRealtime(value); 
                        if (_this.firebaseStorage.getInits())
                            resolve(_this.ordinaryAlgorithm.vhgetObject(obj));
                    })
                        .catch(function (e) { reject(e); });
                }
                else {
                    console.log('wrong information');
                }
            });
    };
    /**
     * Hàm này trả về (Realtime) danh sách những store đã đưa ra cầu hỏi và đang chờ AppCare trở lời
     * @example:
     this.ordinaryQuery.callbackUserListRealtime_ADMIN()
          .subscribe((json)=> {
            console.log('json', json);
            json.docs.forEach(doc => {
              console.log('doc', doc);
              console.log(doc.data());
            })
          })
     * @param callback
     * @return callback JSON => json = {size, empty, docs[]}; json.docs = [{id, data()},{},...]
     */
    OrdinaryQuery.prototype.callbackUserListRealtime_ADMIN = function () {
        var _this = this;
        return rxjs_1.Observable.create(function (observer) {
            _this.callbackChatStore(function () {
                _this.getchatStoreList().then(function (json) {
                    observer.next(json);
                });
            });
        });
    };
    OrdinaryQuery.prototype.callbackChatStore = function (callback) {
        firebase.database().ref('/messages/').on('child_added', function (data) {
            callback(data);
        });
        firebase.database().ref('/messages/').on('child_removed', function (data) {
            callback(data);
        });
        firebase.database().ref('/messages/').on('child_changed', function (data) {
            callback(data);
        });
        firebase.database().ref('/messages/').on('child_moved', function (data) {
            callback(data);
        });
    };
    OrdinaryQuery.prototype.getchatStoreList = function () {
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.database().ref().once('value').then(function (snapshot) {
                    var json = {
                        docs: new Array(),
                        empty: true,
                        size: 0
                    };
                    for (var snap in snapshot.val()) {
                        var _loop_3 = function () {
                            var value = __assign({}, snapshot.val()[snap][s]);
                            if (value.date_ask)
                                value.date_ask = new Date(value.date_ask);
                            var data = {
                                id: (s).replace('_', '.'),
                                database: snap,
                                data: function () {
                                    return value;
                                }
                            };
                            json.docs.push(data);
                            json.empty = false;
                            json.size++;
                        };
                        for (var s in snapshot.val()[snap]) {
                            _loop_3();
                        }
                    }
                    resolve(json);
                });
            });
    };
    OrdinaryQuery.prototype.checkOnline = function () {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                var checkonline = _this.createTask('checklogs', { date: new Date() });
                Promise.all([
                    checkonline
                ])
                    .then(function () {
                    resolve(null);
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     * Hàm này sẽ xoa, không dùng hàm này nhé!
     * @param collection
     * @param id_product
     * @param value
     */
    OrdinaryQuery.prototype.createSubTask = function (collection, id_product, value) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection)
                    .doc(id_product)
                    .collection('subs')
                    .add(value)
                    //obj này chỉ có obj.id ko có obj.data() 
                    .then(function (obj) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhgetObject(obj));
                })
                    .catch(function (e) { return reject(e); });
            });
    };
    /**
     * Hàm này sẽ xoa, không dùng hàm này nhé!
     * @param collection
     * @param id_product
     * @param subID
     * @param value
     */
    OrdinaryQuery.prototype.createSubTask_bySubID = function (collection, id_product, subID, value) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection)
                    .doc(id_product)
                    .collection('subs')
                    .doc(subID)
                    .set(value)
                    //firebase trả về undefined
                    .then(function () {
                    if (_this.firebaseStorage.getInits())
                        resolve(null);
                })
                    .catch(function (e) { return reject(e); });
            });
    };
    /**
     * Hàm này sẽ xoa, không dùng hàm này nhé!
     * @param collection
     * @param id_product
     * @param id_sub_product
     * @param value
     */
    OrdinaryQuery.prototype.updateSubTask = function (collection, id_product, id_sub_product, value) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection)
                    .doc(id_product)
                    .collection('subs')
                    .doc(id_sub_product)
                    .update(value)
                    .then(function () {
                    if (_this.firebaseStorage.getInits())
                        resolve(null);
                })
                    .catch(function (e) { return reject(e); });
            });
    };
    /**
     * Hàm này sẽ xoa, không dùng hàm này nhé!
     * @param collection
     * @param id_product
     * @param id_sub_product
     */
    OrdinaryQuery.prototype.deleteSubTask = function (collection, id_product, id_sub_product) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection)
                    .doc(id_product)
                    .collection('subs')
                    .doc(id_sub_product)
                    .delete()
                    //firebase trả về undefined
                    .then(function () {
                    if (_this.firebaseStorage.getInits())
                        resolve(null);
                })
                    .catch(function (e) { return reject(e); });
            });
    };
    /**
     * Hàm này sẽ xoa, không dùng hàm này nhé!
     * @param collection
     * @param id_product
     * @param id_sub_product
     */
    OrdinaryQuery.prototype.getSubTask = function (collection, id_product, id_sub_product) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection)
                    .doc(id_product)
                    .collection('subs')
                    .doc(id_sub_product)
                    .get()
                    .then(function (snapshot) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhObject(snapshot));
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     * Hàm này sẽ xoa, không dùng hàm này nhé!
     * @param collection
     * @param id_product
     */
    OrdinaryQuery.prototype.getSubTasks = function (collection, id_product) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection)
                    .doc(id_product)
                    .collection('subs')
                    .get()
                    .then(function (snapshots) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhObjects(snapshots));
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     *
     * @param collection
     * @param value
     * @return Promise Object => obj = {id, created}
     */
    OrdinaryQuery.prototype.createTask = function (collection, value) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection)
                    .add(value)
                    //obj này chỉ có obj.id ko có obj.data() 
                    .then(function (obj) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhgetObject(obj));
                })
                    .catch(function (e) { return reject(e); });
            });
    };
    /**
     *
     * @param collection
     * @param value
     * @param id
     * @return Promise Boolean => true or false
     */
    OrdinaryQuery.prototype.overrideTask = function (collection, value, id) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection)
                    .doc(id)
                    .set(value)
                    //firebase trả về undefined
                    .then(function () {
                    if (_this.firebaseStorage.getInits())
                        resolve(true);
                })
                    .catch(function (e) {
                    console.log(e);
                    resolve(false);
                });
            });
    };
    /**
     *
     * @param collection
     * @param id
     * @return Promise JSON => json = {id, data(), exists}
     */
    OrdinaryQuery.prototype.getTask = function (collection, id) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection)
                    .doc(id)
                    .get()
                    .then(function (snapshot) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhObject(snapshot));
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     *
     * @param collection
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    OrdinaryQuery.prototype.getTasks = function (collection) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection)
                    .get()
                    .then(function (snapshots) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhObjects(snapshots));
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     *
     * @param collection
     * @param docKey
     * @param value
     * @return Promise Boolean => true or false
     */
    OrdinaryQuery.prototype.updateTask = function (collection, docKey, value) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection)
                    .doc(docKey)
                    .update(value)
                    //firebase trả về undefined
                    .then(function () {
                    if (_this.firebaseStorage.getInits())
                        resolve(true);
                })
                    .catch(function (e) {
                    console.log(e);
                    resolve(false);
                });
            });
    };
    /**
     *
     * @param collection
     * @param docKey
     * @return Promise Boolean => true or false
     */
    OrdinaryQuery.prototype.deleteTask = function (collection, docKey) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection)
                    .doc(docKey)
                    .delete()
                    //firebase trả về undefined
                    .then(function () {
                    if (_this.firebaseStorage.getInits())
                        resolve(true);
                })
                    .catch(function (e) {
                    console.log(e);
                    resolve(false);
                });
            });
    };
    /**
     *
     * @param collection
     * @param field
     * @param condition
     * @param value
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    OrdinaryQuery.prototype.getTasks_by1Field_1Field1Value = function (collection, field, condition, value) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection).where(field, condition, value)
                    .get()
                    .then(function (snapshots) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhObjects(snapshots));
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     *
     * @param collection
     * @param field
     * @param condition
     * @param value
     * @param orderfield
     * @param order
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    OrdinaryQuery.prototype.getTasks_by1Field_1Field1Value_orderby = function (collection, field, condition, value, orderfield, order) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection).where(field, condition, value)
                    .orderBy(orderfield, order)
                    .get()
                    .then(function (snapshots) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhObjects(snapshots));
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     *
     * @param collection
     * @param field
     * @param condition
     * @param value
     * @param limit
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    OrdinaryQuery.prototype.getTasks_by1Field_1Field1Value_limited = function (collection, field, condition, value, limit) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection).where(field, condition, value)
                    .limit(limit)
                    .get()
                    .then(function (snapshots) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhObjects(snapshots));
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     *
     * @param collection
     * @param field
     * @param condition_a
     * @param value_a
     * @param condition_b
     * @param value_b
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    OrdinaryQuery.prototype.getTasks_by1Field_1Field2Value = function (collection, field, condition_a, value_a, condition_b, value_b) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection).where(field, condition_a, value_a).where(field, condition_b, value_b)
                    .get()
                    .then(function (snapshots) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhObjects(snapshots));
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     *
     * @param collection
     * @param field1
     * @param condition_1a
     * @param value_1a
     * @param condition_1b
     * @param value_1b
     * @param field2
     * @param condition2
     * @param value2
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    OrdinaryQuery.prototype.getTasks_by2Field_1Field2Value_AND_1Field1Value = function (collection, field1, condition_1a, value_1a, condition_1b, value_1b, field2, condition2, value2) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection)
                    .where(field1, condition_1a, value_1a)
                    .where(field1, condition_1b, value_1b)
                    .where(field2, condition2, value2)
                    .get()
                    .then(function (snapshots) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhObjects(snapshots));
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     *
     * @param collection
     * @param field1
     * @param condition1
     * @param value1
     * @param field2
     * @param condition2
     * @param value2
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    OrdinaryQuery.prototype.getTasks_by2Field_1Field1Value_OR_1Field1Value = function (collection, field1, condition1, value1, field2, condition2, value2) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                var const1 = new Promise(function (resolve, reject) {
                    _this.getTasks_by1Field_1Field1Value(collection, field1, condition1, value1)
                        .then(function (snapshots) {
                        resolve(snapshots);
                    }, function (error) {
                        reject(error);
                    });
                });
                var const2 = new Promise(function (resolve, reject) {
                    _this.getTasks_by1Field_1Field1Value(collection, field2, condition2, value2)
                        .then(function (snapshots) {
                        resolve(snapshots);
                    }, function (error) {
                        reject(error);
                    });
                });
                Promise.all([
                    const1,
                    const2
                ]).then(function (snapshots) {
                    var json = __assign({}, snapshots[0]);
                    json.docs = new Array();
                    json.empty = true;
                    json.size = 0;
                    for (var i = 0; i < snapshots.length; i++) {
                        for (var j = 0; j < snapshots[i].size; j++) {
                            json.docs.push(snapshots[i].docs[j]);
                            json.empty = false;
                            json.size = ++json.size;
                        }
                    }
                    if (_this.firebaseStorage.getInits())
                        resolve(json);
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     *
     * @param collection
     * @param field1
     * @param condition1
     * @param value1
     * @param field2
     * @param condition2
     * @param value2
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    OrdinaryQuery.prototype.getTasks_by2Field_1Field1Value_AND_1Field1Value = function (collection, field1, condition1, value1, field2, condition2, value2) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                var const1 = new Promise(function (resolve, reject) {
                    _this.getTasks_by1Field_1Field1Value(collection, field1, condition1, value1)
                        .then(function (snapshots) {
                        resolve(snapshots);
                    }, function (error) {
                        reject(error);
                    });
                });
                var const2 = new Promise(function (resolve, reject) {
                    _this.getTasks_by1Field_1Field1Value(collection, field2, condition2, value2)
                        .then(function (snapshots) {
                        resolve(snapshots);
                    }, function (error) {
                        reject(error);
                    });
                });
                Promise.all([
                    const1,
                    const2
                ]).then(function (snapshots) {
                    var json = __assign({}, snapshots[0]);
                    json.docs = new Array();
                    json.empty = true;
                    json.size = 0;
                    for (var i = 0; i < snapshots[0].size; i++) {
                        for (var j = 0; j < snapshots[1].size; j++) {
                            if (snapshots[1].docs[j].id === snapshots[0].docs[i].id) {
                                json.docs.push(snapshots[1].docs[j]);
                                json.empty = false;
                                json.size = ++json.size;
                            }
                        }
                    }
                    if (_this.firebaseStorage.getInits())
                        resolve(json);
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     *
     * @param collection
     * @param field1
     * @param condition_1a
     * @param value_1a
     * @param condition_1b
     * @param value_1b
     * @param field2
     * @param condition2
     * @param value2
     * @param field3
     * @param condition3
     * @param value3
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    OrdinaryQuery.prototype.getTasks_by3Field_1Field2Value_AND_1Field1Value_AND_1Field1Value = function (collection, field1, condition_1a, value_1a, condition_1b, value_1b, field2, condition2, value2, field3, condition3, value3) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection(collection).where(field1, condition_1a, value_1a)
                    .where(field1, condition_1b, value_1b)
                    .where(field2, condition2, value2)
                    .where(field3, condition3, value3)
                    .get()
                    .then(function (snapshots) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhObjects(snapshots));
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     *
     * @param collection
     * @param field1
     * @param condition1
     * @param value1
     * @param field2
     * @param condition2
     * @param value2
     * @param field3
     * @param condition3
     * @param value3
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    OrdinaryQuery.prototype.getTasks_by3Field_1Field1Value_OR_1Field1Value_OR_1Field1Value = function (collection, field1, condition1, value1, field2, condition2, value2, field3, condition3, value3) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                var const1 = new Promise(function (resolve, reject) {
                    _this.getTasks_by1Field_1Field1Value(collection, field1, condition1, value1)
                        .then(function (snapshots) {
                        resolve(snapshots);
                    }, function (error) {
                        reject(error);
                    });
                });
                var const2 = new Promise(function (resolve, reject) {
                    _this.getTasks_by1Field_1Field1Value(collection, field2, condition2, value2)
                        .then(function (snapshots) {
                        resolve(snapshots);
                    }, function (error) {
                        reject(error);
                    });
                });
                var const3 = new Promise(function (resolve, reject) {
                    _this.getTasks_by1Field_1Field1Value(collection, field3, condition3, value3)
                        .then(function (snapshots) {
                        resolve(snapshots);
                    }, function (error) {
                        reject(error);
                    });
                });
                Promise.all([
                    const1,
                    const2,
                    const3
                ]).then(function (snapshots) {
                    var json = __assign({}, snapshots[0]);
                    json.docs = new Array();
                    json.empty = true;
                    json.size = 0;
                    for (var i = 0; i < snapshots.length; i++) {
                        for (var j = 0; j < snapshots[i].size; j++) {
                            json.docs.push(snapshots[i].docs[j]);
                            json.empty = false;
                            json.size = ++json.size;
                        }
                    }
                    if (_this.firebaseStorage.getInits())
                        resolve(json);
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     *
     * @param collection
     * @param field1
     * @param condition1
     * @param value1
     * @param field2
     * @param condition2
     * @param value2
     * @param field3
     * @param condition3
     * @param value3
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    OrdinaryQuery.prototype.getTasks_by3Field_1Field1Value_AND_1Field1Value_AND_1Field1Value = function (collection, field1, condition1, value1, field2, condition2, value2, field3, condition3, value3) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                var const1 = new Promise(function (resolve, reject) {
                    _this.getTasks_by1Field_1Field1Value(collection, field1, condition1, value1)
                        .then(function (snapshots) {
                        resolve(snapshots);
                    }, function (error) {
                        reject(error);
                    });
                });
                var const2 = new Promise(function (resolve, reject) {
                    _this.getTasks_by1Field_1Field1Value(collection, field2, condition2, value2)
                        .then(function (snapshots) {
                        resolve(snapshots);
                    }, function (error) {
                        reject(error);
                    });
                });
                var const3 = new Promise(function (resolve, reject) {
                    _this.getTasks_by1Field_1Field1Value(collection, field3, condition3, value3)
                        .then(function (snapshots) {
                        resolve(snapshots);
                    }, function (error) {
                        reject(error);
                    });
                });
                Promise.all([
                    const1,
                    const2,
                    const3
                ]).then(function (snapshots) {
                    var json = __assign({}, snapshots[0]);
                    json.docs = new Array();
                    json.empty = true;
                    json.size = 0;
                    for (var i = 0; i < snapshots[0].size; i++) {
                        for (var j = 0; j < snapshots[1].size; j++) {
                            if (snapshots[1].docs[j].id === snapshots[0].docs[i].id) {
                                for (var n = 0; n < snapshots[2].size; n++) {
                                    if (snapshots[2].docs[n].id === snapshots[0].docs[i].id) {
                                        json.docs.push(snapshots[2].docs[n]);
                                        json.empty = false;
                                        json.size = ++json.size;
                                    }
                                }
                            }
                        }
                    }
                    if (_this.firebaseStorage.getInits())
                        resolve(json);
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     *
     * @param collection
     * @param field
     * @param array
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    OrdinaryQuery.prototype.getTasks_by1Field_1Field1Array = function (collection, field, array) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                if (array.length > 0) {
                    var interger_1 = Math.floor(array.length / 10);
                    var surplus_1 = array.length % 10;
                    var count_1 = 0;
                    var array_surplus_1 = [];
                    var array_interger_1 = [];
                    var onlyoneloop_1 = true;
                    var json_1 = {
                        docs: new Array(),
                        empty: true,
                        size: 0
                    };
                    var mysetinterval_1 = setInterval(function () {
                        if (onlyoneloop_1) {
                            // phần dư
                            array_surplus_1 = new Array();
                            for (var i = 0; i < surplus_1; i++) {
                                array_surplus_1[i] = array[i + 10 * interger_1];
                            }
                            if (array_surplus_1.length > 0) {
                                firebase.firestore()
                                    .collection('viethas')
                                    .doc('databases')
                                    .collection(collection)
                                    .where(field, _this.getConditionQuery("in"), array_surplus_1)
                                    .get()
                                    .then(function (resp11) {
                                    for (var j = 0; j < resp11.docs.length; j++) {
                                        json_1.docs.push(_this.ordinaryAlgorithm.vhObjects(resp11).docs[j]);
                                        json_1.empty = false;
                                        json_1.size = ++json_1.size;
                                    }
                                    count_1++;
                                }).catch(function (e) {
                                    console.log("Error querying data:", e);
                                });
                            }
                            else
                                count_1++;
                            //phần nguyên                    
                            for (var m = 0; m < interger_1; m++) {
                                array_interger_1 = new Array();
                                for (var i = 0; i < 10; i++) {
                                    array_interger_1[i] = array[i + 10 * m];
                                }
                                if (array_interger_1.length > 0) {
                                    firebase.firestore()
                                        .collection('viethas')
                                        .doc('databases')
                                        .collection(collection)
                                        .where(field, _this.getConditionQuery("in"), array_interger_1)
                                        .get()
                                        .then(function (resp12) {
                                        for (var j = 0; j < resp12.docs.length; j++) {
                                            json_1.docs.push(_this.ordinaryAlgorithm.vhObjects(resp12).docs[j]);
                                            json_1.empty = false;
                                            json_1.size = ++json_1.size;
                                        }
                                        count_1++;
                                    }).catch(function (e) {
                                        console.log("Error querying data:", e);
                                    });
                                }
                                else
                                    count_1++;
                            }
                            onlyoneloop_1 = false;
                        }
                        if (count_1 == interger_1 + 1) { //1 vì tất cả phần dư truy xuất database 1 lần                                                       
                            clearInterval(mysetinterval_1);
                            if (_this.firebaseStorage.getInits())
                                resolve(json_1);
                        }
                    }, 50);
                }
            });
    };
    /**
     *
     * @param collection
     * @param field1
     * @param condition1
     * @param value1
     * @param field2
     * @param array2
     */
    OrdinaryQuery.prototype.getTasks_by2Field_1Field1Value_AND_1Field1Array = function (collection, field1, condition1, value1, field2, array2) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                if (array2.length > 0) {
                    var interger_2 = Math.floor(array2.length / 10);
                    var surplus_2 = array2.length % 10;
                    var count_2 = 0;
                    var array_surplus_2 = [];
                    var array_interger_2 = [];
                    var onlyoneloop_2 = true;
                    var json_2 = {
                        docs: new Array(),
                        empty: true,
                        size: 0
                    };
                    var mysetinterval_2 = setInterval(function () {
                        if (onlyoneloop_2) {
                            // phần dư
                            array_surplus_2 = new Array();
                            for (var i = 0; i < surplus_2; i++) {
                                array_surplus_2[i] = array2[i + 10 * interger_2];
                            }
                            if (array_surplus_2.length > 0) {
                                firebase.firestore()
                                    .collection('viethas')
                                    .doc('databases')
                                    .collection(collection)
                                    .where(field1, condition1, value1)
                                    .where(field2, _this.getConditionQuery("in"), array_surplus_2)
                                    .get()
                                    .then(function (resp11) {
                                    for (var j = 0; j < resp11.docs.length; j++) {
                                        json_2.docs.push(_this.ordinaryAlgorithm.vhObjects(resp11).docs[j]);
                                        json_2.empty = false;
                                        json_2.size = ++json_2.size;
                                    }
                                    count_2++;
                                }).catch(function (e) {
                                    console.log("Error querying data:", e);
                                });
                            }
                            else
                                count_2++;
                            //phần nguyên                    
                            for (var m = 0; m < interger_2; m++) {
                                array_interger_2 = new Array();
                                for (var i = 0; i < 10; i++) {
                                    array_interger_2[i] = array2[i + 10 * m];
                                }
                                if (array_interger_2.length > 0) {
                                    firebase.firestore()
                                        .collection('viethas')
                                        .doc('databases')
                                        .collection(collection)
                                        .where(field1, condition1, value1)
                                        .where(field2, _this.getConditionQuery("in"), array_interger_2)
                                        .get()
                                        .then(function (resp12) {
                                        for (var j = 0; j < resp12.docs.length; j++) {
                                            json_2.docs.push(_this.ordinaryAlgorithm.vhObjects(resp12).docs[j]);
                                            json_2.empty = false;
                                            json_2.size = ++json_2.size;
                                        }
                                        count_2++;
                                    }).catch(function (e) {
                                        console.log("Error querying data:", e);
                                    });
                                }
                                else
                                    count_2++;
                            }
                            onlyoneloop_2 = false;
                        }
                        if (count_2 == interger_2 + 1) { //1 vì tất cả phần dư truy xuất database 1 lần                                                       
                            clearInterval(mysetinterval_2);
                            if (_this.firebaseStorage.getInits())
                                resolve(json_2);
                        }
                    }, 50);
                }
            });
    };
    /**
     *
     * @param collection
     * @param field1
     * @param condition_1a
     * @param value_1a
     * @param condition_1b
     * @param value_1b
     * @param field2
     * @param array2
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    OrdinaryQuery.prototype.getTasks_by2Field_1Field2Value_AND_1Field1Array = function (collection, field1, condition_1a, value_1a, condition_1b, value_1b, field2, array2) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                if (array2.length > 0) {
                    var interger_3 = Math.floor(array2.length / 10);
                    var surplus_3 = array2.length % 10;
                    var count_3 = 0;
                    var array_surplus_3 = [];
                    var array_interger_3 = [];
                    var onlyoneloop_3 = true;
                    var json_3 = {
                        docs: new Array(),
                        empty: true,
                        size: 0
                    };
                    var mysetinterval_3 = setInterval(function () {
                        if (onlyoneloop_3) {
                            // phần dư
                            array_surplus_3 = new Array();
                            for (var i = 0; i < surplus_3; i++) {
                                array_surplus_3[i] = array2[i + 10 * interger_3];
                            }
                            if (array_surplus_3.length > 0) {
                                firebase.firestore()
                                    .collection('viethas')
                                    .doc('databases')
                                    .collection(collection)
                                    .where(field1, condition_1a, value_1a)
                                    .where(field1, condition_1b, value_1b)
                                    .where(field2, _this.getConditionQuery("in"), array_surplus_3)
                                    .get()
                                    .then(function (resp11) {
                                    for (var j = 0; j < resp11.docs.length; j++) {
                                        json_3.docs.push(_this.ordinaryAlgorithm.vhObjects(resp11).docs[j]);
                                        json_3.empty = false;
                                        json_3.size = ++json_3.size;
                                    }
                                    count_3++;
                                }).catch(function (e) {
                                    console.log("Error querying data:", e);
                                });
                            }
                            else
                                count_3++;
                            //phần nguyên                    
                            for (var m = 0; m < interger_3; m++) {
                                array_interger_3 = new Array();
                                for (var i = 0; i < 10; i++) {
                                    array_interger_3[i] = array2[i + 10 * m];
                                }
                                if (array_interger_3.length > 0) {
                                    firebase.firestore()
                                        .collection('viethas')
                                        .doc('databases')
                                        .collection(collection)
                                        .where(field1, condition_1a, value_1a)
                                        .where(field1, condition_1b, value_1b)
                                        .where(field2, _this.getConditionQuery("in"), array_interger_3)
                                        .get()
                                        .then(function (resp12) {
                                        for (var j = 0; j < resp12.docs.length; j++) {
                                            json_3.docs.push(_this.ordinaryAlgorithm.vhObjects(resp12).docs[j]);
                                            json_3.empty = false;
                                            json_3.size = ++json_3.size;
                                        }
                                        count_3++;
                                    }).catch(function (e) {
                                        console.log("Error querying data:", e);
                                    });
                                }
                                else
                                    count_3++;
                            }
                            onlyoneloop_3 = false;
                        }
                        if (count_3 == interger_3 + 1) { //1 vì tất cả phần dư truy xuất database 1 lần                                                       
                            clearInterval(mysetinterval_3);
                            if (_this.firebaseStorage.getInits())
                                resolve(json_3);
                        }
                    }, 50);
                }
            });
    };
    /**
     *
     * @param collection
     * @param field1
     * @param condition_1a
     * @param value_1a
     * @param condition_1b
     * @param value_1b
     * @param field2
     * @param condition2
     * @param value2
     * @param field3
     * @param array3
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    OrdinaryQuery.prototype.getTasks_by3Field_1Field2Value_AND_1Field1Value_AND_1Field1Array = function (collection, field1, condition_1a, value_1a, condition_1b, value_1b, field2, condition2, value2, field3, array3) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                if (array3.length > 0) {
                    var interger_4 = Math.floor(array3.length / 10);
                    var surplus_4 = array3.length % 10;
                    var count_4 = 0;
                    var array_surplus_4 = [];
                    var array_interger_4 = [];
                    var onlyoneloop_4 = true;
                    var json_4 = {
                        docs: new Array(),
                        empty: true,
                        size: 0
                    };
                    var mysetinterval = setInterval(function () {
                        if (onlyoneloop_4) {
                            // phần dư
                            array_surplus_4 = new Array();
                            for (var i = 0; i < surplus_4; i++) {
                                array_surplus_4[i] = array3[i + 10 * interger_4];
                            }
                            if (array_surplus_4.length > 0) {
                                firebase.firestore()
                                    .collection('viethas')
                                    .doc('databases')
                                    .collection(collection)
                                    .where(field1, condition_1a, value_1a)
                                    .where(field1, condition_1b, value_1b)
                                    .where(field2, condition2, value2)
                                    .where(field3, _this.getConditionQuery("in"), array_surplus_4)
                                    .get()
                                    .then(function (resp11) {
                                    for (var j = 0; j < resp11.docs.length; j++) {
                                        json_4.docs.push(_this.ordinaryAlgorithm.vhObjects(resp11).docs[j]);
                                        json_4.empty = false;
                                        json_4.size = ++json_4.size;
                                    }
                                    count_4++;
                                }).catch(function (e) {
                                    console.log("Error querying data:", e);
                                });
                            }
                            else
                                count_4++;
                            //phần nguyên                    
                            for (var m = 0; m < interger_4; m++) {
                                array_interger_4 = new Array();
                                for (var i = 0; i < 10; i++) {
                                    array_interger_4[i] = array3[i + 10 * m];
                                }
                                if (array_interger_4.length > 0) {
                                    firebase.firestore()
                                        .collection('viethas')
                                        .doc('databases')
                                        .collection(collection)
                                        .where(field1, condition_1a, value_1a)
                                        .where(field1, condition_1b, value_1b)
                                        .where(field2, condition2, value2)
                                        .where(field3, _this.getConditionQuery("in"), array_interger_4)
                                        .get()
                                        .then(function (resp12) {
                                        for (var j = 0; j < resp12.docs.length; j++) {
                                            json_4.docs.push(_this.ordinaryAlgorithm.vhObjects(resp12).docs[j]);
                                            json_4.empty = false;
                                            json_4.size = ++json_4.size;
                                        }
                                        count_4++;
                                    }).catch(function (e) {
                                        console.log("Error querying data:", e);
                                    });
                                }
                                else
                                    count_4++;
                            }
                            onlyoneloop_4 = false;
                        }
                        if (count_4 == interger_4 + 1) { //1 vì tất cả phần dư truy xuất database 1 lần                                                       
                            clearInterval(mysetinterval);
                            if (_this.firebaseStorage.getInits())
                                resolve(json_4);
                        }
                    }, 50);
                }
            });
    };
    /**
     *
     * @param collection
     * @param field1
     * @param condition1
     * @param value1
     * @param field2
     * @param condition2
     * @param value2
     * @param field3
     * @param array3
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    OrdinaryQuery.prototype.getTasks_by3Field_1Field1Value_AND_1Field1Value_AND_1Field1Array = function (collection, field1, condition1, value1, field2, condition2, value2, field3, array3) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                if (array3.length > 0) {
                    var interger_5 = Math.floor(array3.length / 10);
                    var surplus_5 = array3.length % 10;
                    var count_5 = 0;
                    var array_surplus_5 = [];
                    var array_interger_5 = [];
                    var onlyoneloop_5 = true;
                    var json_5 = {
                        docs: new Array(),
                        empty: true,
                        size: 0
                    };
                    var mysetinterval = setInterval(function () {
                        if (onlyoneloop_5) {
                            // phần dư
                            array_surplus_5 = new Array();
                            for (var i = 0; i < surplus_5; i++) {
                                array_surplus_5[i] = array3[i + 10 * interger_5];
                            }
                            if (array_surplus_5.length > 0) {
                                firebase.firestore()
                                    .collection('viethas')
                                    .doc('databases')
                                    .collection(collection)
                                    .where(field1, condition1, value1)
                                    .where(field2, condition2, value2)
                                    .where(field3, _this.getConditionQuery("in"), array_surplus_5)
                                    .get()
                                    .then(function (resp11) {
                                    for (var j = 0; j < resp11.docs.length; j++) {
                                        json_5.docs.push(_this.ordinaryAlgorithm.vhObjects(resp11).docs[j]);
                                        json_5.empty = false;
                                        json_5.size = ++json_5.size;
                                    }
                                    count_5++;
                                }).catch(function (e) {
                                    console.log("Error querying data:", e);
                                });
                            }
                            else
                                count_5++;
                            //phần nguyên                    
                            for (var m = 0; m < interger_5; m++) {
                                array_interger_5 = new Array();
                                for (var i = 0; i < 10; i++) {
                                    array_interger_5[i] = array3[i + 10 * m];
                                }
                                if (array_interger_5.length > 0) {
                                    firebase.firestore()
                                        .collection('viethas')
                                        .doc('databases')
                                        .collection(collection)
                                        .where(field1, condition1, value1)
                                        .where(field2, condition2, value2)
                                        .where(field3, _this.getConditionQuery("in"), array_interger_5)
                                        .get()
                                        .then(function (resp12) {
                                        for (var j = 0; j < resp12.docs.length; j++) {
                                            json_5.docs.push(_this.ordinaryAlgorithm.vhObjects(resp12).docs[j]);
                                            json_5.empty = false;
                                            json_5.size = ++json_5.size;
                                        }
                                        count_5++;
                                    }).catch(function (e) {
                                        console.log("Error querying data:", e);
                                    });
                                }
                                else
                                    count_5++;
                            }
                            onlyoneloop_5 = false;
                        }
                        if (count_5 == interger_5 + 1) { //1 vì tất cả phần dư truy xuất database 1 lần                                                       
                            clearInterval(mysetinterval);
                            if (_this.firebaseStorage.getInits())
                                resolve(json_5);
                        }
                    }, 50);
                }
            });
    };
    /**
     *
     * @param collection
     * @param value
     * @return Promise Object => obj = {id, created}
     */
    OrdinaryQuery.prototype.createSetting = function (collection, value) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection('vhsettings')
                    .doc(collection)
                    .collection(collection)
                    .add(value)
                    .then(function (obj) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhgetObject(obj));
                })
                    .catch(function (e) { return reject(e); });
            });
    };
    /**
     *
     * @param collection
     * @param docKey
     * @param value
     * @return Promise Boolean => true or false
     */
    OrdinaryQuery.prototype.updateSetting = function (collection, docKey, value) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection('vhsettings')
                    .doc(collection)
                    .collection(collection)
                    .doc(docKey)
                    .update(value)
                    //firebase trả về undefined
                    .then(function () {
                    if (_this.firebaseStorage.getInits())
                        resolve(true);
                })
                    .catch(function (e) {
                    console.log(e);
                    resolve(false);
                });
            });
    };
    /**
     *
     * @param collection
     * @param id
     * @return Promise JSON => json = {id, data(), exists}
     */
    OrdinaryQuery.prototype.getSetting = function (collection, id) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection('vhsettings')
                    .doc(collection)
                    .collection(collection)
                    .doc(id)
                    .get()
                    .then(function (snapshot) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhObject(snapshot));
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     *
     * @param collection
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    OrdinaryQuery.prototype.getSettings = function (collection) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection('vhsettings')
                    .doc(collection)
                    .collection(collection)
                    .get()
                    .then(function (snapshots) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhObjects(snapshots));
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     *
     * @param collection
     * @param docKey
     * @return Promise Boolean => true or false
     */
    OrdinaryQuery.prototype.deleteSetting = function (collection, docKey) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('databases')
                    .collection('vhsettings')
                    .doc(collection)
                    .collection(collection)
                    .doc(docKey)
                    .delete()
                    //firebase trả về undefined
                    .then(function () {
                    if (_this.firebaseStorage.getInits())
                        resolve(true);
                })
                    .catch(function (e) {
                    console.log(e);
                    resolve(false);
                });
            });
    };
    /**
     * @example
     let promise_0 = new Promise((resolve, reject)=>{});
     let promise_1 = new Promise((resolve, reject)=>{});
     this.get2Tasks_by2Promise(promise_0, promise_1)
        .then((array)=>{
          console.log(array[0]);
          console.log(array[1]);
        })
     * @param promise1
     * @param promise2
     * @return Promise Array => array[0] and array[1]
     */
    OrdinaryQuery.prototype.get2Tasks_by2Promise = function (promise1, promise2) {
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                Promise.all([
                    promise1,
                    promise2
                ]).then(function (snapshots) {
                    resolve(snapshots);
                }, function (error) {
                    reject(error);
                });
            });
    };
    OrdinaryQuery.prototype.async_startPromise = function (ordinal) {
        this.promiseArray[ordinal] = new Array();
    };
    OrdinaryQuery.prototype.async_importPromiseOne = function (ordinal, promise) {
        this.promiseArray[ordinal].push(promise);
    };
    OrdinaryQuery.prototype.async_waitingPromiseAll = function (ordinal) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                Promise.all(_this.promiseArray[ordinal])
                    .then(function (values) {
                    resolve(values);
                })
                    .catch(function (error) {
                    reject(error);
                });
            });
    };
    /**
     let promise = new Array();
     for(let i=0; i<length; i++){
       promise[i] = new Promise((resolve, reject)=>{});
     }
     this.async_waiting_newPromiseAll(promise)
        .then((array)=>{
          console.log(array);
        })
     * @param array
     * @return Promise Array => array =[, , , ,...]
     */
    OrdinaryQuery.prototype.async_waiting_newPromiseAll = function (array) {
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                Promise.all(array)
                    .then(function (values) {
                    resolve(values);
                })
                    .catch(function (error) {
                    reject(error);
                });
            });
    };
    OrdinaryQuery = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [FirebaseAuth, FirebaseStorage, http_1.Http, OrdinaryAlgorithm])
    ], OrdinaryQuery);
    return OrdinaryQuery;
}());
exports.OrdinaryQuery = OrdinaryQuery;
var FirebaseImage = /** @class */ (function () {
    function FirebaseImage(firebaseStorage, firebaseAuth, ordinaryComponent) {
        this.firebaseStorage = firebaseStorage;
        this.firebaseAuth = firebaseAuth;
        this.ordinaryComponent = ordinaryComponent;
        this.sid = null;
        this.edatabase = true;
        this._DB = firebase.firestore();
        this.auth = firebase.auth();
        this.sid = this.firebaseAuth.sid;
    }
    //giữ lại
    FirebaseImage.prototype.encodeImageUri = function (imageUri, callback) {
        var c = document.createElement('canvas');
        var ctx = c.getContext('2d');
        var img = new Image();
        img.onload = function () {
            var aux = this;
            c.width = aux.width;
            c.height = aux.height;
            ctx.drawImage(img, 0, 0);
            var dataURL = c.toDataURL('image/jpeg');
            callback(dataURL);
        };
        img.src = imageUri;
    };
    //giữ lại
    FirebaseImage.prototype.uploadImage = function (component, imageURI, randomId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var storageRef = firebase.storage().ref();
            var imageRef = storageRef.child(component).child('image').child(randomId);
            _this.encodeImageUri(imageURI, function (image64) {
                imageRef.putString(image64, 'data_url')
                    .then(function (snapshot) {
                    snapshot.ref.getDownloadURL()
                        .then(function (res) { return resolve(res); });
                }, function (err) {
                    reject(err);
                });
            });
        });
    };
    //giữ lại
    FirebaseImage.prototype.encodeThumbnailUri = function (imageUri, w, h, callback) {
        var c = document.createElement('canvas');
        var ctx = c.getContext('2d');
        var img = new Image();
        //lỗi thường xảy ra ở onload này, khắc phục npm install rxjs@6.0.0
        img.onload = function () {
            var aux = this;
            c.width = w;
            c.height = h;
            ctx.drawImage(img, 0, 0, w, h);
            var dataURL = c.toDataURL('image/jpeg');
            callback(dataURL);
        };
        img.src = imageUri;
    };
    //giữ lại
    FirebaseImage.prototype.uploadThumbnail = function (component, imageURI, randomId, w, h) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var storageRef = firebase.storage().ref();
            var imageRef = storageRef.child(component).child('thumbnail').child(randomId);
            _this.encodeThumbnailUri(imageURI, w, h, function (image64) {
                imageRef.putString(image64, 'data_url')
                    .then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (res) { return resolve(res); });
                }, function (err) {
                    reject(err);
                });
            });
        });
    };
    /**
     * @example:
     * const file = e.target.files[0];
      this.ordinaryComponent.showLoading((this.languageService.translate("Please wait...")));
      this.firebaseImage.getImageFromDesktop('news', file).then(
        photoURL => {
          this.product.controls["img"].setValue(photoURL);
          this.ordinaryComponent.hideLoading(100);
          this.ordinaryComponent.showToast(2000, (this.languageService.translate("Image was loaded successfully")));
        },
        () => {
          this.ordinaryComponent.hideLoading(100);
          this.ordinaryComponent.showToast(2000, (this.languageService.translate("Image was failed")));
        }
      );
     * @param file
     */
    FirebaseImage.prototype.getImageFromDesktop = function (component, file) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                var reader = new FileReader();
                reader.addEventListener('load', function (event) {
                    var randomId = Math.random().toString(36).substr(2, 5);
                    //uploads img to firebase storage
                    _this.uploadImage(component, event.target.result, randomId)
                        .then(function (photoURL) {
                        resolve(photoURL);
                    }, function (err) {
                        reject(err);
                    });
                });
                reader.readAsDataURL(file);
            });
    };
    /**
     *
     * @param file const file = e.target.files[0];
      this.ordinaryComponent.showLoading((this.languageService.translate("Please wait...")));
      this.firebaseImage.getThumbnailFromDesktop('news', file, 128, 128).then(
        photoURL => {
          this.product.controls["img"].setValue(photoURL);
          this.ordinaryComponent.hideLoading(100);
          this.ordinaryComponent.showToast(2000, (this.languageService.translate("Image was loaded successfully")));
        },
        () => {
          this.ordinaryComponent.hideLoading(100);
          this.ordinaryComponent.showToast(2000, (this.languageService.translate("Image was failed")));
        }
      );
     * @param w
     * @param h
     */
    FirebaseImage.prototype.getThumbnailFromDesktop = function (component, file, w, h) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                var reader = new FileReader();
                reader.addEventListener('load', function (event) {
                    var randomId = Math.random().toString(36).substr(2, 5);
                    //uploads img to firebase storage        
                    _this.uploadThumbnail(component, event.target.result, randomId, w, h)
                        .then(function (photoURL) {
                        resolve(photoURL);
                    }, function (err) {
                        reject(err);
                    });
                });
                reader.readAsDataURL(file);
            });
    };
    FirebaseImage.prototype.deleteImage = function (imageURI) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var storageRef = firebase.storage().ref();
            //Create a reference to the file to delete
            //let imageRef = storageRef.child('alkrep');
            var regex = /2F[a-zA-Z]{5}\?/;
            var result = regex.exec(imageURI); // lấy các giá trị 2Fxxxxx?
            var filename = String(result).slice(2, 7);
            var rootRef = storageRef.child(_this.sid).child('image');
            var imageRef = rootRef.child(filename);
            //Delete the file
            imageRef.delete()
                .then(function (success) {
                //File deleted successfully         
                resolve(success);
            }, function (error) {
                //Uh-oh, an error occurred!
                reject(error);
            });
        });
    };
    FirebaseImage.prototype.deleteThumbnail = function (thumbnailURI) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var storageRef = firebase.storage().ref();
            //Create a reference to the file to delete
            //let imageRef = storageRef.child('alkrep');
            var regex = /2F[a-zA-Z]{5}\?/;
            var result = regex.exec(thumbnailURI); // lấy các giá trị 2Fxxxxx?
            var filename = String(result).slice(2, 7);
            var rootRef = storageRef.child(_this.sid).child('thumbnail');
            var imageRef = rootRef.child(filename);
            // Delete the file
            imageRef.delete()
                .then(function (success) {
                //File deleted successfully         
                resolve(success);
            }, function (error) {
                //Uh-oh, an error occurred!
                reject(error);
            });
        });
    };
    FirebaseImage = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [FirebaseStorage,
            FirebaseAuth,
            OrdinaryComponent])
    ], FirebaseImage);
    return FirebaseImage;
}());
exports.FirebaseImage = FirebaseImage;
var QueryVhweb = /** @class */ (function () {
    //private localPermission: any = {};
    //private localPermissions: any = {};
    function QueryVhweb(firebaseStorage, firebaseAuth, ordinaryQuery, ordinaryComponent, ordinaryAlgorithm) {
        this.firebaseStorage = firebaseStorage;
        this.firebaseAuth = firebaseAuth;
        this.ordinaryQuery = ordinaryQuery;
        this.ordinaryComponent = ordinaryComponent;
        this.ordinaryAlgorithm = ordinaryAlgorithm;
        this.edatabase = true;
    }
    QueryVhweb.prototype.getConditionQuery = function (condition) {
        return condition;
    };
    /**
     * @example:
     * this.queryVhweb.addData_SKHDT({name : "Gold"})
            .then((res)=>{
              console.log('addData_SKHDT', res);
            }, error=>{
              console.log('error', error);
            })
      * @param data
      * @return Promise => object or error
      */
    QueryVhweb.prototype.addData_SKHDT = function (data) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('data_SKHDTs')
                .add(data)
                .then(function (doc) {
                var obj = __assign({}, data);
                obj._id = doc.id;
                resolve(obj);
            })
                .catch(function (e) {
                console.log(e);
                reject(e);
            });
        });
    };
    /**
     * @example:
     * this.queryVhweb.updateData_SKHDT('KNOVIYWKN135468',{id_commission : "321SDWC65DWSVDFS"})
          .then((bool)=>{
            console.log('updateData_SKHDT', bool);
          }, error=>{
            console.log('error', error);
          })
    * @param id_data_SKHDTs
    * @param data
    * @return Promise => bool = true or false
    */
    QueryVhweb.prototype.updateData_SKHDT = function (id_data_SKHDTs, data) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('data_SKHDTs')
                .doc(id_data_SKHDTs)
                .update(data)
                .then(function () {
                resolve(true);
            })
                .catch(function (e) {
                console.log(e);
                resolve(false);
            });
        });
    };
    /**
    * @example:
    * this.queryVhweb.deleteData_SKHDT('KNOVIYWKN135468')
          .then((bool)=>{
            console.log('deleteData_SKHDT', bool);
          }, error=>{
            console.log('error', error);
          })
    * @param id_data_SKHDTs
    * @return Promise => bool = true or false
    */
    QueryVhweb.prototype.deleteData_SKHDT = function (id_data_SKHDTs) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('data_SKHDTs')
                .doc(id_data_SKHDTs)
                .delete()
                .then(function () {
                resolve(true);
            })
                .catch(function (e) {
                console.log(e);
                resolve(false);
            });
        });
    };
    /**
    * @example:
    * this.queryVhweb.getData_SKHDT('KNOVIYWKN135468')
          .then((res)=>{
            console.log('getData_SKHDT', res);
          }, error=>{
            console.log('error', error);
          })
    * @param id_data_SKHDTs
    * @return Promise => object or null
    */
    QueryVhweb.prototype.getData_SKHDT = function (id_data_SKHDTs) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('data_SKHDTs')
                .doc(id_data_SKHDTs)
                .get()
                .then(function (doc) {
                if (doc.exists) {
                    var obj = _this.ordinaryAlgorithm.cvtDataFB2MG(doc.data());
                    obj._id = doc.id;
                    resolve(obj);
                }
                else
                    resolve(null);
            }, function (error) {
                console.log('error', error);
                reject(error);
            });
        });
    };
    /**
    * @example:
    * this.queryVhweb.getData_SKHDTs()
          .then((array)=>{
            console.log('getData_SKHDTs', array);
          }, error=>{
            console.log('error', error);
          })
    * @return Promise => Array<object> => array = [{},{},...]
    */
    QueryVhweb.prototype.getData_SKHDTs = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('data_SKHDTs')
                .get()
                .then(function (json) {
                var array = new Array();
                json.docs.forEach(function (doc) {
                    array.push(_this.ordinaryAlgorithm.cvtDataFB2MG(doc.data()));
                    array[array.length - 1]._id = doc.id;
                });
                resolve(array);
            }, function (error) {
                console.log('error', error);
                reject(error);
            });
        });
    };
    /**
    * @example:
       let endtime = new Date();
       let starttime = new Date('2020-07-01T05:24:00');
       this.queryVhweb.getData_SKHDTs_byFields({license_date:{$gte:starttime, $lte:endtime}}, {}, {license_date:1},0)
         .then((response)=>{
           console.log('getData_SKHDTs_byFields', response);
         })
         .catch((e)=>{
           console.log('e', e)
         })
     * @param query : {}
     * @param projection {} đang tìm hiểu
     * @param sort null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
     * @param limit null hoặc 0: không giới hạn record get về; 2: get về 2 record
     * @return Array -> array = [{},{},...]
     * @notice : trường hợp ko get đc data thì array.length = 0;
     */
    QueryVhweb.prototype.getData_SKHDTs_byFields = function (query, projection, sort, limit) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var fields = new Array();
            var methods = new Array();
            var vals = new Array();
            for (var p in query) {
                fields.push(p);
                if (Object.keys(query[p]).length === 2)
                    fields.push(p);
                for (var q in query[p]) {
                    methods.push(q);
                    vals.push(query[p][q]);
                }
            }
            for (var i = 0; i < methods.length; i++) {
                if (methods[i] === '$eq')
                    methods[i] = '==';
                else if (methods[i] === '$ne')
                    methods[i] = '!=';
                else if (methods[i] === '$lte')
                    methods[i] = '<=';
                else if (methods[i] === '$gte')
                    methods[i] = '>=';
                else if (methods[i] === '$in')
                    methods[i] = 'in';
            }
            var fb = firebase.firestore().collection('data_SKHDTs');
            for (var i = 0; i < fields.length; i++) {
                fb = fb['where'](fields[i], methods[i], vals[i]);
            }
            var sort_fields = new Array();
            var sort_vals = new Array();
            for (var p in sort) {
                sort_fields.push(p);
                if (sort[p] === 1)
                    sort_vals.push('asc');
                else if (sort[p] === -1)
                    sort_vals.push('desc');
            }
            for (var i = 0; i < sort_fields.length; i++) {
                fb = fb['orderBy'](sort_fields[i], sort_vals[i]);
            }
            if ((limit != undefined) && (limit != null) && (limit > 0))
                fb = fb['limit'](limit);
            fb.get()
                .then(function (json) {
                var array = new Array();
                json.docs.forEach(function (doc) {
                    array.push(_this.ordinaryAlgorithm.cvtDataFB2MG(doc.data()));
                    array[array.length - 1]._id = doc.id;
                });
                resolve(array);
            });
        });
    };
    /**
     * @example:
     * this.queryVhweb.addCommission_CareStaff_payment({name : "Gold"})
            .then((res)=>{
              console.log('addCommission_CareStaff_payment', res);
            }, error=>{
              console.log('error', error);
            })
      * @param data
      * @return Promise => object or error
      */
    QueryVhweb.prototype.addCommission_CareStaff_payment = function (data) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('commission_carestaff_payments')
                .add(data)
                .then(function (doc) {
                var obj = __assign({}, data);
                obj._id = doc.id;
                resolve(obj);
            })
                .catch(function (e) {
                console.log(e);
                reject(e);
            });
        });
    };
    /**
     * @example:
     * this.queryVhweb.updateCommission_CareStaff_Payment('KNOVIYWKN135468',{name : "Hoa"})
            .then((bool)=>{
              console.log('updateCommission_CareStaff_Payment', bool);
            }, error=>{
              console.log('error', error);
            })
      * @param id_commission_carestaff_payment
      * @param data
      * @return Promise => bool = true or false
      */
    QueryVhweb.prototype.updateCommission_CareStaff_Payment = function (id_commission_carestaff_payment, data) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('commission_carestaff_payments')
                .doc(id_commission_carestaff_payment)
                .update(data)
                .then(function () {
                resolve(true);
            })
                .catch(function (e) {
                console.log(e);
                resolve(false);
            });
        });
    };
    /**
     * @example:
     * this.queryVhweb.deleteCommission_CareStaff_Payment('KNOVIYWKN135468')
            .then((bool)=>{
              console.log('deleteCommission_CareStaff_Payment', bool);
            }, error=>{
              console.log('error', error);
            })
      * @param id_commission_carestaff_payment
      * @return Promise => bool = true or false
      */
    QueryVhweb.prototype.deleteCommission_CareStaff_Payment = function (id_commission_carestaff_payment) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('commission_carestaff_payments')
                .doc(id_commission_carestaff_payment)
                .delete()
                .then(function () {
                resolve(true);
            })
                .catch(function (e) {
                console.log(e);
                resolve(false);
            });
        });
    };
    /**
     * @example:
     * this.queryVhweb.getCommission_CareStaff_Payment('KNOVIYWKN135468')
            .then((res)=>{
              console.log('getCommission_CareStaff_Payment', res);
            }, error=>{
              console.log('error', error);
            })
      * @param id_commission_carestaff_payment
      * @return Promise => object or null
      */
    QueryVhweb.prototype.getCommission_CareStaff_Payment = function (id_commission_carestaff_payment) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('commission_carestaff_payments')
                .doc(id_commission_carestaff_payment)
                .get()
                .then(function (doc) {
                if (doc.exists) {
                    var obj = _this.ordinaryAlgorithm.cvtDataFB2MG(doc.data());
                    obj._id = doc.id;
                    resolve(obj);
                }
                else
                    resolve(null);
            }, function (error) {
                console.log('error', error);
                reject(error);
            });
        });
    };
    /**
     * @example:
     * this.queryVhweb.getCommission_CareStaff_Payments()
            .then((array)=>{
              console.log('getCommission_CareStaff_Payments', array);
            }, error=>{
              console.log('error', error);
            })
      * @return Promise => Array<object> => array = [{},{},...]
      */
    QueryVhweb.prototype.getCommission_CareStaff_Payments = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('commission_carestaff_payments')
                .get()
                .then(function (json) {
                var array = new Array();
                json.docs.forEach(function (doc) {
                    array.push(_this.ordinaryAlgorithm.cvtDataFB2MG(doc.data()));
                    array[array.length - 1]._id = doc.id;
                });
                resolve(array);
            }, function (error) {
                console.log('error', error);
                reject(error);
            });
        });
    };
    /**
     * @example:
     * this.queryVhweb.addCommission_Salesman_payment({name : "Gold"})
            .then((res)=>{
              console.log('addCommission_Salesman_payment', res);
            }, error=>{
              console.log('error', error);
            })
      * @param data
      * @return Promise => object or error
      */
    QueryVhweb.prototype.addCommission_Salesman_payment = function (data) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('commission_salesman_payments')
                .add(data)
                .then(function (doc) {
                var obj = __assign({}, data);
                obj._id = doc.id;
                resolve(obj);
            })
                .catch(function (e) {
                console.log(e);
                reject(e);
            });
        });
    };
    /**
     * @example:
     * this.queryVhweb.updateCommission_Salesman_Payment('KNOVIYWKN135468',{name : "Hoa"})
            .then((bool)=>{
              console.log('updateCommission_Salesman_Payment', bool);
            }, error=>{
              console.log('error', error);
            })
      * @param id_commission_salesman_payment
      * @param data
      * @return Promise => bool = true or false
      */
    QueryVhweb.prototype.updateCommission_Salesman_Payment = function (id_commission_salesman_payment, data) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('commission_salesman_payments')
                .doc(id_commission_salesman_payment)
                .update(data)
                .then(function () {
                resolve(true);
            })
                .catch(function (e) {
                console.log(e);
                resolve(false);
            });
        });
    };
    /**
     * @example:
     * this.queryVhweb.deleteCommission_Salesman_Payment('KNOVIYWKN135468')
            .then((bool)=>{
              console.log('deleteCommission_Salesman_Payment', bool);
            }, error=>{
              console.log('error', error);
            })
      * @param id_commission_salesman_payment
      * @return Promise => bool = true or false
      */
    QueryVhweb.prototype.deleteCommission_Salesman_Payment = function (id_commission_salesman_payment) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('commission_salesman_payments')
                .doc(id_commission_salesman_payment)
                .delete()
                .then(function () {
                resolve(true);
            })
                .catch(function (e) {
                console.log(e);
                resolve(false);
            });
        });
    };
    /**
     * @example:
     * this.queryVhweb.getCommission_Salesman_Payment('KNOVIYWKN135468')
            .then((res)=>{
              console.log('getCommission_Salesman_Payment', res);
            }, error=>{
              console.log('error', error);
            })
      * @param id_commission_salesman_payment
      * @return Promise => object or null
      */
    QueryVhweb.prototype.getCommission_Salesman_Payment = function (id_commission_salesman_payment) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('commission_salesman_payments')
                .doc(id_commission_salesman_payment)
                .get()
                .then(function (doc) {
                if (doc.exists) {
                    var obj = _this.ordinaryAlgorithm.cvtDataFB2MG(doc.data());
                    obj._id = doc.id;
                    resolve(obj);
                }
                else
                    resolve(null);
            }, function (error) {
                console.log('error', error);
                reject(error);
            });
        });
    };
    /**
     * @example:
     * this.queryVhweb.getCommission_Salesman_Payments()
            .then((array)=>{
              console.log('getCommission_Salesman_Payments', array);
            }, error=>{
              console.log('error', error);
            })
      * @return Promise => Array<object> => array = [{},{},...]
      */
    QueryVhweb.prototype.getCommission_Salesman_Payments = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('commission_salesman_payments')
                .get()
                .then(function (json) {
                var array = new Array();
                json.docs.forEach(function (doc) {
                    array.push(_this.ordinaryAlgorithm.cvtDataFB2MG(doc.data()));
                    array[array.length - 1]._id = doc.id;
                });
                resolve(array);
            }, function (error) {
                console.log('error', error);
                reject(error);
            });
        });
    };
    /**
     * @example:
     * this.queryVhweb.addWallet({name : "Gold"})
            .then((res)=>{
              console.log('addWallet', res);
            }, error=>{
              console.log('error', error);
            })
      * @param data
      * @return Promise => object or error
      */
    QueryVhweb.prototype.addWallet = function (data) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('wallets')
                .add(data)
                .then(function (doc) {
                var obj = __assign({}, data);
                obj._id = doc.id;
                resolve(obj);
            })
                .catch(function (e) {
                console.log(e);
                reject(e);
            });
        });
    };
    /**
    * @example:
    * this.queryVhweb.updateWallet('KNOVIYWKN135468',{id_commission : "321SDWC65DWSVDFS"})
          .then((bool)=>{
            console.log('updateWallet', bool);
          }, error=>{
            console.log('error', error);
          })
    * @param id_wallet
    * @param data
    * @return Promise => bool = true or false
    */
    QueryVhweb.prototype.updateWallet = function (id_wallet, data) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('wallets')
                .doc(id_wallet)
                .update(data)
                .then(function () {
                resolve(true);
            })
                .catch(function (e) {
                console.log(e);
                resolve(false);
            });
        });
    };
    /**
    * @example:
    * this.queryVhweb.deleteWallet('KNOVIYWKN135468')
          .then((bool)=>{
            console.log('deleteWallet', bool);
          }, error=>{
            console.log('error', error);
          })
    * @param id_wallet
    * @return Promise => bool = true or false
    */
    QueryVhweb.prototype.deleteWallet = function (id_wallet) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('wallets')
                .doc(id_wallet)
                .delete()
                .then(function () {
                resolve(true);
            })
                .catch(function (e) {
                console.log(e);
                resolve(false);
            });
        });
    };
    /**
    * @example:
    * this.queryVhweb.getWallet('KNOVIYWKN135468')
          .then((res)=>{
            console.log('getWallet', res);
          }, error=>{
            console.log('error', error);
          })
    * @param id_wallet
    * @return Promise => object or null
    */
    QueryVhweb.prototype.getWallet = function (id_wallet) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('wallets')
                .doc(id_wallet)
                .get()
                .then(function (doc) {
                if (doc.exists) {
                    var obj = _this.ordinaryAlgorithm.cvtDataFB2MG(doc.data());
                    obj._id = doc.id;
                    resolve(obj);
                }
                else
                    resolve(null);
            }, function (error) {
                console.log('error', error);
                reject(error);
            });
        });
    };
    /**
    * @example:
    * this.queryVhweb.getWallets()
          .then((array)=>{
            console.log('getWallets', array);
          }, error=>{
            console.log('error', error);
          })
    * @return Promise => Array<object> => array = [{},{},...]
    */
    QueryVhweb.prototype.getWallets = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('wallets')
                .get()
                .then(function (json) {
                var array = new Array();
                json.docs.forEach(function (doc) {
                    array.push(_this.ordinaryAlgorithm.cvtDataFB2MG(doc.data()));
                    array[array.length - 1]._id = doc.id;
                });
                resolve(array);
            }, function (error) {
                console.log('error', error);
                reject(error);
            });
        });
    };
    /**
     * @example:
     * this.queryVhweb.addSalesmanClass({name : "Gold"})
            .then((res)=>{
              console.log('addSalesmanClass', res);
            }, error=>{
              console.log('error', error);
            })
      * @param data
      * @return Promise => object or error
      */
    QueryVhweb.prototype.addSalesmanClass = function (data) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('salesman_classs')
                .add(data)
                .then(function (doc) {
                var obj = __assign({}, data);
                obj._id = doc.id;
                resolve(obj);
            })
                .catch(function (e) {
                console.log(e);
                reject(e);
            });
        });
    };
    /**
     * @example:
     * this.queryVhweb.updateSalesmanClass('KNOVIYWKN135468',{id_commission : "321SDWC65DWSVDFS"})
            .then((bool)=>{
              console.log('updateSalesmanClass', bool);
            }, error=>{
              console.log('error', error);
            })
      * @param id_salesman_class
      * @param data
      * @return Promise => bool = true or false
      */
    QueryVhweb.prototype.updateSalesmanClass = function (id_salesman_class, data) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('salesman_classs')
                .doc(id_salesman_class)
                .update(data)
                .then(function () {
                resolve(true);
            })
                .catch(function (e) {
                console.log(e);
                resolve(false);
            });
        });
    };
    /**
      * @example:
      * this.queryVhweb.deleteSalesmanClass('KNOVIYWKN135468')
            .then((bool)=>{
              console.log('deleteSalesmanClass', bool);
            }, error=>{
              console.log('error', error);
            })
      * @param id_partner_class
      * @return Promise => bool = true or false
      */
    QueryVhweb.prototype.deleteSalesmanClass = function (id_partner_class) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('salesman_classs')
                .doc(id_partner_class)
                .delete()
                .then(function () {
                resolve(true);
            })
                .catch(function (e) {
                console.log(e);
                resolve(false);
            });
        });
    };
    /**
      * @example:
      * this.queryVhweb.getSalesmanClass('KNOVIYWKN135468')
            .then((res)=>{
              console.log('getSalesmanClass', res);
            }, error=>{
              console.log('error', error);
            })
      * @param id_salesman_class
      * @return Promise => object or null
      */
    QueryVhweb.prototype.getSalesmanClass = function (id_salesman_class) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('salesman_classs')
                .doc(id_salesman_class)
                .get()
                .then(function (doc) {
                if (doc.exists) {
                    var obj = _this.ordinaryAlgorithm.cvtDataFB2MG(doc.data());
                    obj._id = doc.id;
                    resolve(obj);
                }
                else
                    resolve(null);
            }, function (error) {
                console.log('error', error);
                reject(error);
            });
        });
    };
    /**
      * @example:
      * this.queryVhweb.getSalesmanClasss()
            .then((array)=>{
              console.log('getSalesmanClasss', array);
            }, error=>{
              console.log('error', error);
            })
      * @return Promise => Array<object> => array = [{},{},...]
      */
    QueryVhweb.prototype.getSalesmanClasss = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('salesman_classs')
                .get()
                .then(function (json) {
                var array = new Array();
                json.docs.forEach(function (doc) {
                    array.push(_this.ordinaryAlgorithm.cvtDataFB2MG(doc.data()));
                    array[array.length - 1]._id = doc.id;
                });
                resolve(array);
            }, function (error) {
                console.log('error', error);
                reject(error);
            });
        });
    };
    /**
   * @example:
   * this.queryVhweb.addCareStaffClass({name : "Gold"})
          .then((res)=>{
            console.log('addCareStaffClass', res);
          }, error=>{
            console.log('error', error);
          })
    * @param data
    * @return Promise => object or error
    */
    QueryVhweb.prototype.addCareStaffClass = function (data) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('carestaff_classs')
                .add(data)
                .then(function (doc) {
                var obj = __assign({}, data);
                obj._id = doc.id;
                resolve(obj);
            })
                .catch(function (e) {
                console.log(e);
                reject(e);
            });
        });
    };
    /**
     * @example:
     * this.queryVhweb.updateCareStaffClass('KNOVIYWKN135468',{id_commission : "321SDWC65DWSVDFS"})
            .then((bool)=>{
              console.log('updateCareStaffClass', bool);
            }, error=>{
              console.log('error', error);
            })
      * @param id_carestaff_class
      * @param data
      * @return Promise => bool = true or false
      */
    QueryVhweb.prototype.updateCareStaffClass = function (id_carestaff_class, data) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('carestaff_classs')
                .doc(id_carestaff_class)
                .update(data)
                .then(function () {
                resolve(true);
            })
                .catch(function (e) {
                console.log(e);
                resolve(false);
            });
        });
    };
    /**
      * @example:
      * this.queryVhweb.deleteCareStaffClass('KNOVIYWKN135468')
            .then((bool)=>{
              console.log('deleteCareStaffClass', bool);
            }, error=>{
              console.log('error', error);
            })
      * @param id_carestaff_class
      * @return Promise => bool = true or false
      */
    QueryVhweb.prototype.deleteCareStaffClass = function (id_carestaff_class) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('carestaff_classs')
                .doc(id_carestaff_class)
                .delete()
                .then(function () {
                resolve(true);
            })
                .catch(function (e) {
                console.log(e);
                resolve(false);
            });
        });
    };
    /**
      * @example:
      * this.queryVhweb.getCareStaffClass('KNOVIYWKN135468')
            .then((res)=>{
              console.log('getCareStaffClass', res);
            }, error=>{
              console.log('error', error);
            })
      * @param id_carestaff_class
      * @return Promise => object or null
      */
    QueryVhweb.prototype.getCareStaffClass = function (id_carestaff_class) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('carestaff_classs')
                .doc(id_carestaff_class)
                .get()
                .then(function (doc) {
                if (doc.exists) {
                    var obj = _this.ordinaryAlgorithm.cvtDataFB2MG(doc.data());
                    obj._id = doc.id;
                    resolve(obj);
                }
                else
                    resolve(null);
            }, function (error) {
                console.log('error', error);
                reject(error);
            });
        });
    };
    /**
      * @example:
      * this.queryVhweb.getCareStaffClasss()
            .then((array)=>{
              console.log('getCareStaffClasss', array);
            }, error=>{
              console.log('error', error);
            })
      * @return Promise => Array<object> => array = [{},{},...]
      */
    QueryVhweb.prototype.getCareStaffClasss = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('carestaff_classs')
                .get()
                .then(function (json) {
                var array = new Array();
                json.docs.forEach(function (doc) {
                    array.push(_this.ordinaryAlgorithm.cvtDataFB2MG(doc.data()));
                    array[array.length - 1]._id = doc.id;
                });
                resolve(array);
            }, function (error) {
                console.log('error', error);
                reject(error);
            });
        });
    };
    /**
     * @note Tên collection trùng tên component, và là duy nhất
     * @param component
     * @param value
     * @param id_parent
     * Nếu truyền id_parent vào hàm, thì component này có component cha
     * Nếu không truyền id_parent vào hàm, thì component này là component độc lập
     * @return Promise Object => obj = {id, created}
     */
    QueryVhweb.prototype.createComponent_USER = function (component, value, id_parent) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                if (id_parent != undefined)
                    value.id_parent = id_parent;
                else
                    value.id_parent = '';
                firebase.firestore()
                    .collection('viethas')
                    .doc('vhucomponents')
                    .collection(component)
                    .add(value)
                    //obj này chỉ có obj.id ko có obj.data() 
                    .then(function (obj) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhgetObject(obj));
                })
                    .catch(function (e) { return reject(e); });
            });
    };
    /**
     * @note Tên collection trùng tên component, và là duy nhất
     * @param component
     * @param docKey
     * @param value
     * @return Promise Boolean => true or false
     */
    QueryVhweb.prototype.updateComponent_USER = function (component, docKey, value) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('vhucomponents')
                    .collection(component)
                    .doc(docKey)
                    .update(value)
                    //firebase trả về undefined
                    .then(function () {
                    if (_this.firebaseStorage.getInits())
                        resolve(true);
                })
                    .catch(function (e) {
                    console.log(e);
                    resolve(false);
                });
            });
    };
    /**
     * @note Tên collection trùng tên component, và là duy nhất
     * @param component
     * @param docKey
     * @return Promise Boolean => true or false
     */
    QueryVhweb.prototype.deleteComponent_USER = function (component, docKey) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('vhucomponents')
                    .collection(component)
                    .doc(docKey)
                    .delete()
                    //firebase trả về undefined
                    .then(function () {
                    if (_this.firebaseStorage.getInits())
                        resolve(true);
                })
                    .catch(function (e) {
                    console.log(e);
                    resolve(false);
                });
            });
    };
    /**
     * @note Tên collection trùng tên component, và là duy nhất
     * @param component
     * @param docKey
     * @param id_parent
     * Nếu truyền id_parent vào hàm, thì component này có component cha
     * Nếu không truyền id_parent vào hàm, thì component này là component độc lập
     * @return Promise Boolean => true or false
     */
    QueryVhweb.prototype.deleteComponent_byParentID_USER = function (component, id_parent) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                if (id_parent != undefined) {
                    _this.getComponents(component, id_parent)
                        .then(function (components) {
                        if (components.size > 0) {
                            for (var i = 0; i < components.size; i++) {
                                _this.deleteComponent(component, components.docs[i].id);
                            }
                        }
                        resolve(true);
                    });
                }
                else {
                    _this.getComponents(component)
                        .then(function (components) {
                        if (components.size > 0) {
                            for (var i = 0; i < components.size; i++) {
                                _this.deleteComponent(component, components.docs[i].id);
                            }
                        }
                        resolve(true);
                    });
                }
            });
    };
    /**
     * @note Tên collection trùng tên component, và là duy nhất
     * @param component
     * @param docKey
     * @return Promise JSON => json = {id, data(), exists}
     */
    QueryVhweb.prototype.getComponent_USER = function (component, docKey) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('vhucomponents')
                    .collection(component)
                    .doc(docKey)
                    .get()
                    .then(function (obj) {
                    var json;
                    if (obj.exists) {
                        json = {
                            id: obj.id,
                            exists: true,
                            data: function () {
                                var data = obj.data();
                                delete data.id_parent;
                                return data;
                            }
                        };
                    }
                    else {
                        json = {
                            id: obj.id,
                            exists: false,
                            data: function () {
                                return undefined;
                            }
                        };
                    }
                    // nhớ xóa id_parent trước khi xuất ra
                    if (_this.firebaseStorage.getInits())
                        resolve(json);
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     * @note Tên collection trùng tên component, và là duy nhất
     * @param component
     * @param id_parent
     * Nếu truyền id_parent vào hàm, thì component này có component cha
     * Nếu không truyền id_parent vào hàm, thì component này là component độc lập
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    QueryVhweb.prototype.getComponents_USER = function (component, id_parent) {
        var _this = this;
        // nhớ xóa id_parent trước khi xuất ra
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                if (id_parent != undefined) {
                    firebase.firestore()
                        .collection('viethas')
                        .doc('vhucomponents')
                        .collection(component)
                        .where('id_parent', '==', id_parent)
                        .get()
                        .then(function (objs) {
                        var json = {
                            docs: new Array(),
                            empty: true,
                            size: 0
                        };
                        if (objs.size > 0) {
                            json.empty = false;
                            var _loop_4 = function (i) {
                                var data = {
                                    id: objs.docs[i].id,
                                    data: function () {
                                        var data = __assign({}, objs.docs[i].data());
                                        delete data.id_parent;
                                        return data;
                                    }
                                };
                                json.docs.push(data);
                                json.size++;
                            };
                            for (var i = 0; i < objs.size; i++) {
                                _loop_4(i);
                            }
                        }
                        if (_this.firebaseStorage.getInits())
                            resolve(json);
                    }, function (error) {
                        reject(error);
                    });
                }
                else {
                    firebase.firestore()
                        .collection('viethas')
                        .doc('vhucomponents')
                        .collection(component)
                        .where('id_parent', '==', '')
                        .get()
                        .then(function (objs) {
                        var json = {
                            docs: new Array(),
                            empty: true,
                            size: 0
                        };
                        if (objs.size > 0) {
                            json.empty = false;
                            var _loop_5 = function (i) {
                                var data = {
                                    id: objs.docs[i].id,
                                    data: function () {
                                        var data = __assign({}, objs.docs[i].data());
                                        delete data.id_parent;
                                        return data;
                                    }
                                };
                                json.docs.push(data);
                                json.size++;
                            };
                            for (var i = 0; i < objs.size; i++) {
                                _loop_5(i);
                            }
                        }
                        if (_this.firebaseStorage.getInits())
                            resolve(json);
                    }, function (error) {
                        reject(error);
                    });
                }
            });
    };
    /**
    * @note Tên collection trùng tên component, và là duy nhất
    * @param component
    * @param value
    * @param id_parent
    * Nếu truyền id_parent vào hàm, thì component này có component cha
    * Nếu không truyền id_parent vào hàm, thì component này là component độc lập
    * @return Promise Object => obj = {id, created}
    */
    QueryVhweb.prototype.createComponent = function (component, value, id_parent) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                if (id_parent != undefined)
                    value.id_parent = id_parent;
                else
                    value.id_parent = '';
                firebase.firestore()
                    .collection('viethas')
                    .doc('components')
                    .collection(component)
                    .add(value)
                    //obj này chỉ có obj.id ko có obj.data() 
                    .then(function (obj) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhgetObject(obj));
                })
                    .catch(function (e) { return reject(e); });
            });
    };
    /**
     * @note Tên collection trùng tên component, và là duy nhất
     * @param component
     * @param docKey
     * @param value
     * @return Promise Boolean => true or false
     */
    QueryVhweb.prototype.updateComponent = function (component, docKey, value) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('components')
                    .collection(component)
                    .doc(docKey)
                    .update(value)
                    //firebase trả về undefined
                    .then(function () {
                    if (_this.firebaseStorage.getInits())
                        resolve(true);
                })
                    .catch(function (e) {
                    console.log(e);
                    resolve(false);
                });
            });
    };
    /**
     * @note Tên collection trùng tên component, và là duy nhất
     * @param component
     * @param docKey
     * @return Promise Boolean => true or false
     */
    QueryVhweb.prototype.deleteComponent = function (component, docKey) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('components')
                    .collection(component)
                    .doc(docKey)
                    .delete()
                    //firebase trả về undefined
                    .then(function () {
                    if (_this.firebaseStorage.getInits())
                        resolve(true);
                })
                    .catch(function (e) {
                    console.log(e);
                    resolve(false);
                });
            });
    };
    /**
     * @note Tên collection trùng tên component, và là duy nhất
     * @param component
     * @param docKey
     * @param id_parent
     * Nếu truyền id_parent vào hàm, thì component này có component cha
     * Nếu không truyền id_parent vào hàm, thì component này là component độc lập
     * @return Promise Boolean => true or false
     */
    QueryVhweb.prototype.deleteComponent_byParentID = function (component, id_parent) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                if (id_parent != undefined) {
                    _this.getComponents(component, id_parent)
                        .then(function (components) {
                        if (components.size > 0) {
                            for (var i = 0; i < components.size; i++) {
                                _this.deleteComponent(component, components.docs[i].id);
                            }
                        }
                        resolve(true);
                    });
                }
                else {
                    _this.getComponents(component)
                        .then(function (components) {
                        if (components.size > 0) {
                            for (var i = 0; i < components.size; i++) {
                                _this.deleteComponent(component, components.docs[i].id);
                            }
                        }
                        resolve(true);
                    });
                }
            });
    };
    /**
     * @note Tên collection trùng tên component, và là duy nhất
     * @param component
     * @param docKey
     * @return Promise JSON => json = {id, data(), exists}
     */
    QueryVhweb.prototype.getComponent = function (component, docKey) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('components')
                    .collection(component)
                    .doc(docKey)
                    .get()
                    .then(function (obj) {
                    var json;
                    if (obj.exists) {
                        json = {
                            id: obj.id,
                            exists: true,
                            data: function () {
                                var data = obj.data();
                                delete data.id_parent;
                                return data;
                            }
                        };
                    }
                    else {
                        json = {
                            id: obj.id,
                            exists: false,
                            data: function () {
                                return undefined;
                            }
                        };
                    }
                    // nhớ xóa id_parent trước khi xuất ra
                    if (_this.firebaseStorage.getInits())
                        resolve(json);
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     * @note Tên collection trùng tên component, và là duy nhất
     * @param component
     * @param id_parent
     * Nếu truyền id_parent vào hàm, thì component này có component cha
     * Nếu không truyền id_parent vào hàm, thì component này là component độc lập
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    QueryVhweb.prototype.getComponents = function (component, id_parent) {
        var _this = this;
        // nhớ xóa id_parent trước khi xuất ra
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                if (id_parent != undefined) {
                    firebase.firestore()
                        .collection('viethas')
                        .doc('components')
                        .collection(component)
                        .where('id_parent', '==', id_parent)
                        .get()
                        .then(function (objs) {
                        var json = {
                            docs: new Array(),
                            empty: true,
                            size: 0
                        };
                        if (objs.size > 0) {
                            json.empty = false;
                            var _loop_6 = function (i) {
                                var data = {
                                    id: objs.docs[i].id,
                                    data: function () {
                                        var data = __assign({}, objs.docs[i].data());
                                        delete data.id_parent;
                                        return data;
                                    }
                                };
                                json.docs.push(data);
                                json.size++;
                            };
                            for (var i = 0; i < objs.size; i++) {
                                _loop_6(i);
                            }
                        }
                        if (_this.firebaseStorage.getInits())
                            resolve(json);
                    }, function (error) {
                        reject(error);
                    });
                }
                else {
                    firebase.firestore()
                        .collection('viethas')
                        .doc('components')
                        .collection(component)
                        .where('id_parent', '==', '')
                        .get()
                        .then(function (objs) {
                        var json = {
                            docs: new Array(),
                            empty: true,
                            size: 0
                        };
                        if (objs.size > 0) {
                            json.empty = false;
                            var _loop_7 = function (i) {
                                var data = {
                                    id: objs.docs[i].id,
                                    data: function () {
                                        var data = __assign({}, objs.docs[i].data());
                                        delete data.id_parent;
                                        return data;
                                    }
                                };
                                json.docs.push(data);
                                json.size++;
                            };
                            for (var i = 0; i < objs.size; i++) {
                                _loop_7(i);
                            }
                        }
                        if (_this.firebaseStorage.getInits())
                            resolve(json);
                    }, function (error) {
                        reject(error);
                    });
                }
            });
    };
    /**
     *  @example:
     *  this.queryVhweb.createProduct('testdata', {title: 'title', content: 'content'})
          .then((result)=>{
            if(result.created){
              console.log('result.id', result.id);
            }
          })
     * @param collection
     * @param value
     * @return Promise Object => obj = {id, created}
     */
    QueryVhweb.prototype.createProduct = function (collection, value) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                if (value === null || value === void 0 ? void 0 : value.id_parent)
                    delete value.id_parent;
                firebase.firestore()
                    .collection('viethas')
                    .doc('vhdatabases')
                    .collection(collection)
                    .add(value)
                    //obj này chỉ có obj.id ko có obj.data() 
                    .then(function (obj) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhgetObject(obj));
                })
                    .catch(function (e) { return reject(e); });
            });
    };
    /**
     * @example:
     *  this.queryVhweb.getProduct('testdata', '5qZeXtJMV8DDycZ3dPpN')
          .then((result)=>{
            if(result.exists){
              console.log('result.id', result.id);
              console.log('result.data()', result.data());
            }
          })
     * @param collection
     * @param docKey
     * @return Promise JSON => json = {id, data(), exists}
     */
    QueryVhweb.prototype.getProduct = function (collection, docKey) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('vhdatabases')
                    .collection(collection)
                    .doc(docKey)
                    .get()
                    .then(function (obj) {
                    var json;
                    if (obj.exists) {
                        json = {
                            id: obj.id,
                            exists: true,
                            data: function () {
                                var data = obj.data();
                                if (data === null || data === void 0 ? void 0 : data.id_parent)
                                    delete data.id_parent;
                                return data;
                            }
                        };
                    }
                    else {
                        json = {
                            id: obj.id,
                            exists: false,
                            data: function () {
                                return undefined;
                            }
                        };
                    }
                    if (_this.firebaseStorage.getInits())
                        resolve(json);
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     * @example:
     *  this.queryVhweb.getProducts('testdata')
            .then((result)=>{
              if(!result.empty){
                for(let i=0; i<result.size; i++){
                  console.log('result', result.docs[i].id);
                  console.log('result.data()', result.docs[i].data());
                }
              }
              
            })
     * @param collection
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    QueryVhweb.prototype.getProducts = function (collection) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('vhdatabases')
                    .collection(collection)
                    .get()
                    .then(function (objs) {
                    var json = {
                        docs: new Array(),
                        empty: true,
                        size: 0
                    };
                    if (objs.size > 0) {
                        var _loop_8 = function (i) {
                            var data = {
                                id: objs.docs[i].id,
                                data: function () {
                                    var data = objs.docs[i].data();
                                    if (data === null || data === void 0 ? void 0 : data.id_parent)
                                        delete data.id_parent;
                                    return data;
                                }
                            };
                            json.docs.push(data);
                            json.size++;
                            json.empty = false;
                        };
                        for (var i = 0; i < objs.size; i++) {
                            _loop_8(i);
                        }
                    }
                    if (_this.firebaseStorage.getInits())
                        resolve(json);
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     * @example:
     * this.queryVhweb.updateProduct('testdata', '5qZeXtJMV8DDycZ3dPpN', {data:"data1"})
          .then((result)=>{
            console.log('result', result);
          })
     * @param collection
     * @param docKey
     * @param value
     * @return Promise Boolean => true or false
     */
    QueryVhweb.prototype.updateProduct = function (collection, docKey, value) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                if (value === null || value === void 0 ? void 0 : value.id_parent)
                    delete value.id_parent;
                firebase.firestore()
                    .collection('viethas')
                    .doc('vhdatabases')
                    .collection(collection)
                    .doc(docKey)
                    .update(value)
                    //firebase trả về undefined
                    .then(function () {
                    if (_this.firebaseStorage.getInits())
                        resolve(true);
                })
                    .catch(function (e) {
                    console.log(e);
                    resolve(false);
                });
            });
    };
    /**
     * @example:
     * this.queryVhweb.deleteProduct('testdata', '5qZeXtJMV8DDycZ3dPpN')
          .then((result)=>{
            console.log('result', result);
          })
     * @param collection
     * @param docKey
     * @return Promise Boolean => true or false
     */
    QueryVhweb.prototype.deleteProduct = function (collection, docKey) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('vhdatabases')
                    .collection(collection)
                    .doc(docKey)
                    .delete()
                    //firebase trả về undefined
                    .then(function () {
                    if (_this.firebaseStorage.getInits())
                        resolve(true);
                })
                    .catch(function (e) {
                    console.log(e);
                    resolve(false);
                });
            });
    };
    /**
     * @example:
     * this.queryVhweb.selectProduct('testdata', '5qZeXtJMV8DDycZ3dPpN', "idprent5")
          .then((result)=>{
            console.log('result', result);
          })
     * @param collection
     * @param docKey
     * @param id_parent
     * @return Promise Boolean => true or false
     */
    QueryVhweb.prototype.selectProduct = function (collection, docKey, id_parent) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('vhdatabases')
                    .collection(collection)
                    .doc(docKey)
                    .get()
                    .then(function (task) {
                    var _a;
                    if (task.exists) {
                        var exist = false;
                        var array = new Array();
                        if ((_a = task.data()) === null || _a === void 0 ? void 0 : _a.id_parent) {
                            //console.log('task1.data()?.id_parent', task.data()?.id_parent);
                            array = task.data().id_parent;
                            for (var i = 0; i < task.data().id_parent.length; i++) {
                                if (task.data().id_parent[i] == id_parent) {
                                    exist = true;
                                    break;
                                }
                            }
                            if (!exist) {
                                array.push(id_parent);
                                firebase.firestore()
                                    .collection('viethas')
                                    .doc('vhdatabases')
                                    .collection(collection)
                                    .doc(docKey)
                                    .update({ id_parent: array })
                                    //firebase trả về undefined
                                    .then(function () {
                                    if (_this.firebaseStorage.getInits())
                                        resolve(true);
                                })
                                    .catch(function (e) {
                                    console.log(e);
                                    resolve(false);
                                });
                            }
                            else {
                                resolve(true);
                            }
                        }
                        else {
                            //console.log('task2.data()?.id_parent', task.data()?.id_parent);
                            array.push(id_parent);
                            firebase.firestore()
                                .collection('viethas')
                                .doc('vhdatabases')
                                .collection(collection)
                                .doc(docKey)
                                .update({ id_parent: array })
                                //firebase trả về undefined
                                .then(function () {
                                if (_this.firebaseStorage.getInits())
                                    resolve(true);
                            })
                                .catch(function (e) {
                                console.log(e);
                                resolve(false);
                            });
                        }
                    }
                    else {
                        resolve(false);
                    }
                }, function (error) {
                    console.log(error);
                    resolve(false);
                });
            });
    };
    /**
     * @example:
     *  this.queryVhweb.unSelectProduct('testdata', 'lGvqug9RaKw25SB05UJE', "idprent8")
          .then((result)=>{
            console.log('result', result);
          })
     * @param collection
     * @param docKey
     * @param id_parent
     * @return Promise Boolean => true or false
     */
    QueryVhweb.prototype.unSelectProduct = function (collection, docKey, id_parent) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('vhdatabases')
                    .collection(collection)
                    .doc(docKey)
                    .get()
                    .then(function (task) {
                    var _a;
                    if (task.exists) {
                        var exist = false;
                        var array = new Array();
                        if ((_a = task.data()) === null || _a === void 0 ? void 0 : _a.id_parent) {
                            array = task.data().id_parent;
                            for (var i = 0; i < task.data().id_parent.length; i++) {
                                if (task.data().id_parent[i] == id_parent) {
                                    exist = true;
                                    break;
                                }
                            }
                            if (exist) {
                                var newarray = array.filter(function (word) { return word != id_parent; });
                                firebase.firestore()
                                    .collection('viethas')
                                    .doc('vhdatabases')
                                    .collection(collection)
                                    .doc(docKey)
                                    .update({ id_parent: newarray })
                                    //firebase trả về undefined
                                    .then(function () {
                                    if (_this.firebaseStorage.getInits())
                                        resolve(true);
                                })
                                    .catch(function (e) {
                                    console.log(e);
                                    resolve(false);
                                });
                            }
                            else {
                                resolve(true);
                            }
                        }
                        else {
                            resolve(true);
                        }
                    }
                    else {
                        resolve(false);
                    }
                }, function (error) {
                    console.log(error);
                    resolve(false);
                });
            });
    };
    /**
     * @example:
     *  this.queryVhweb.getSelectedProducts('testdata', 'idprent8')
            .then((result)=>{
              if(!result.empty){
                for(let i=0; i<result.size; i++){
                  console.log('result', result.docs[i].id);
                  console.docs[i].log('result.data()', result.docs[i].data());
                }
              }
              
            })
     * @param collection
     * @param id_parent
     * @return Promise JSONs => json.docs = [{id, data(), size, empty},{}...]
     */
    QueryVhweb.prototype.getSelectedProducts = function (collection, id_parent) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('vhdatabases')
                    .collection(collection)
                    .where('id_parent', 'array-contains', id_parent)
                    .get()
                    .then(function (snapshots) {
                    if (_this.firebaseStorage.getInits())
                        resolve(_this.ordinaryAlgorithm.vhObjects(snapshots));
                }, function (error) {
                    reject(error);
                });
            });
    };
    /**
     * @example:
     * this.queryVhweb.getUnSelectProducts('testdata', "idprent8")
          .then((result)=>{
            if(!result.empty){
              for(let i=0; i<result.size; i++){
                console.log('result', result.docs[i].id);
                console.log('result.docs[i].data()', result.docs[i].data());
              }
            }
          })
     * @param collection
     * @param id_parent
     */
    QueryVhweb.prototype.getUnSelectProducts = function (collection, id_parent) {
        var _this = this;
        if (this.edatabase)
            return new Promise(function (resolve, reject) {
                firebase.firestore()
                    .collection('viethas')
                    .doc('vhdatabases')
                    .collection(collection)
                    .get()
                    .then(function (objs) {
                    var _a, _b;
                    var json = {
                        docs: new Array(),
                        empty: true,
                        size: 0
                    };
                    if (objs.size > 0) {
                        var _loop_9 = function (i) {
                            var exist = false;
                            for (var j = 0; j < ((_b = (_a = objs.docs[i].data()) === null || _a === void 0 ? void 0 : _a.id_parent) === null || _b === void 0 ? void 0 : _b.length); j++) {
                                if (objs.docs[i].data().id_parent[j] == id_parent) {
                                    exist = true;
                                    break;
                                }
                            }
                            if (!exist) {
                                var data = {
                                    id: objs.docs[i].id,
                                    data: function () {
                                        var data = objs.docs[i].data();
                                        if (data === null || data === void 0 ? void 0 : data.id_parent)
                                            delete data.id_parent;
                                        return data;
                                    }
                                };
                                json.docs.push(data);
                                json.size++;
                                json.empty = false;
                            }
                        };
                        for (var i = 0; i < objs.size; i++) {
                            _loop_9(i);
                        }
                    }
                    if (_this.firebaseStorage.getInits())
                        resolve(json);
                }, function (error) {
                    reject(error);
                });
            });
    };
    QueryVhweb = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [FirebaseStorage,
            FirebaseAuth,
            OrdinaryQuery,
            OrdinaryComponent,
            OrdinaryAlgorithm])
    ], QueryVhweb);
    return QueryVhweb;
}());
exports.QueryVhweb = QueryVhweb;
var QueryVhAPP = /** @class */ (function () {
    function QueryVhAPP(firebaseStorage, firebaseAuth, ordinaryQuery, ordinaryComponent, ordinaryAlgorithm) {
        this.firebaseStorage = firebaseStorage;
        this.firebaseAuth = firebaseAuth;
        this.ordinaryQuery = ordinaryQuery;
        this.ordinaryComponent = ordinaryComponent;
        this.ordinaryAlgorithm = ordinaryAlgorithm;
    }
    /**
     * @description: Lấy về tất cả các cửa hàng (endusers) đã đăng ký vào hệ thống phần mềm, theo thời gian
     * @example:
     * let starttime = new Date('2022-03-13T05:24:00');
     * let endtime = new Date();
     * this.queryVhAPP.getEndUsers_byTime(starttime, endtime, 'bvhsales')
           .then(result=>{
             console.log('result', result);
           }, error=>{
             console.log('error', error);
           })
     * @param starttime
     * @param endtime
     * @param project : vhsales, vhcafe, bvhsales, bvhcafe
     * @returns Promise Array
     */
    QueryVhAPP.prototype.getEndUsers_byTime = function (starttime, endtime, project) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var body = { starttime: starttime, endtime: endtime, project: project };
            _this.firebaseAuth.checkSignedIn()
                .then(function (bool) {
                if (bool) {
                    axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/getendusersappfromvhwebbytime', __assign({}, body))
                        .then(function (response) {
                        if (response.data.vcode === 0)
                            resolve(response.data.data);
                        else
                            reject(response.data);
                    })
                        .catch(function (e) {
                        reject(e);
                    });
                }
                else {
                    reject({ vcode: 50, message: 'you are logged out' });
                }
            });
        });
    };
    /**
   * @description: Lấy về tất cả các cửa hàng (endusers) đã đăng ký vào hệ thống phần mềm, theo thời gian, theo nhân viên
   * @example:
   * let starttime = new Date('2022-03-13T05:24:00');
   * let endtime = new Date();
   * this.queryVhAPP.getEndUsers_byTime_byEmployee(starttime, endtime, 'JU9vVWaZlvXGwZgX6IvyJo8oEG12','bvhsales')
         .then(result=>{
           console.log('result', result);
         }, error=>{
           console.log('error', error);
         })
   * @param starttime
   * @param endtime
   * @param id_partner : 'all' or id_employeee = 'JU9vVWaZlvXGwZgX6IvyJo8oEG12'
   * @param project : vhsales, vhcafe, bvhsales, bvhcafe
   * @returns Promise Array
   */
    QueryVhAPP.prototype.getEndUsers_byTime_byPartner = function (starttime, endtime, id_partner, project) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var body = { starttime: starttime, endtime: endtime, id_partner: id_partner, project: project };
            _this.firebaseAuth.checkSignedIn()
                .then(function (bool) {
                if (bool) {
                    axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/getendusersappfromvhwebbytimebyemployee', __assign({}, body))
                        .then(function (response) {
                        if (response.data.vcode === 0)
                            resolve(response.data.data);
                        else
                            reject(response.data);
                    })
                        .catch(function (e) {
                        reject(e);
                    });
                }
                else {
                    reject({ vcode: 50, message: 'you are logged out' });
                }
            });
        });
    };
    /**
     * @description: Lấy về cửa hàng (store) đã đăng ký vào hệ thống phần mềm theo email
     * @example:
     * this.queryVhAPP.getEndUser_byEmail('cuahangdochoi@gmail.com','bvhsales')
           .then(result=>{
             console.log('result', result);
           }, error=>{
             console.log('error', error);
           })
     * @param email
     * @param project : vhsales, vhcafe, bvhsales, bvhcafe
     * @returns Promise Array
     */
    QueryVhAPP.prototype.getEndUser_byEmail = function (email, project) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var body = { email: email, project: project };
            _this.firebaseAuth.checkSignedIn()
                .then(function (bool) {
                if (bool) {
                    axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/getenduserappfromvhwebbyemail', __assign({}, body))
                        .then(function (response) {
                        if (response.data.vcode === 0)
                            resolve(response.data.data);
                        else
                            reject(response.data);
                    })
                        .catch(function (e) {
                        reject(e);
                    });
                }
                else {
                    reject({ vcode: 50, message: 'you are logged out' });
                }
            });
        });
    };
    /**
     * @description: Lấy về cửa hàng (store) đã đăng ký vào hệ thống phần mềm theo phone number
     * @example:
     * this.queryVhAPP.getStore_byPhoneNumber('903456123','bvhsales')
           .then(result=>{
             console.log('result', result);
           }, error=>{
             console.log('error', error);
           })
     * @param phone
     * @param project : vhsales, vhcafe, bvhsales, bvhcafe
     * @returns Promise Array
     */
    QueryVhAPP.prototype.getEndUser_byPhoneNumber = function (phone, project) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var body = { phone: phone, project: project };
            _this.firebaseAuth.checkSignedIn()
                .then(function (bool) {
                if (bool) {
                    axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/getenduserappfromvhwebbyphonenumber', __assign({}, body))
                        .then(function (response) {
                        if (response.data.vcode === 0)
                            resolve(response.data.data);
                        else
                            reject(response.data);
                    })
                        .catch(function (e) {
                        reject(e);
                    });
                }
                else {
                    reject({ vcode: 50, message: 'you are logged out' });
                }
            });
        });
    };
    /**
     * @description: Lấy về tất cả các cửa hàng (endusers) đã đăng ký vào hệ thống phần mềm, theo thời gian, theo nhân viên cskh, theo tình trạng cửa hàng
     * @example:
     * let starttime = new Date('2022-03-13T05:24:00');
     * let endtime = new Date();
     * this.queryVhAPP.getEndUsers_byTime_byCareStaff_byStatusStore(starttime, endtime, 'JU9vVWaZlvXGwZgX6IvyJo8oEG12', 1, project)
           .then(result=>{
             console.log('result', result);
           }, error=>{
             console.log('error', error);
           })
     * @param starttime
     * @param endtime
     * @param id_carestaff : 'all' or id_employeee = 'JU9vVWaZlvXGwZgX6IvyJo8oEG12'
     * @param status_store : 'all' or 1,2,3,4, or 5................
     * @param project : vhsales, vhcafe, bvhsales, bvhcafe
     * @returns Promise Array
     */
    QueryVhAPP.prototype.getEndUsers_byTime_byCareStaff_byStatusStore = function (starttime, endtime, id_carestaff, status_store, project) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var body = { starttime: starttime, endtime: endtime, id_carestaff: id_carestaff, status_store: status_store, project: project };
            _this.firebaseAuth.checkSignedIn()
                .then(function (bool) {
                if (bool) {
                    axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/getendusersappfromvhwebbytimebycarestaffbystatusstore', __assign({}, body))
                        .then(function (response) {
                        if (response.data.vcode === 0)
                            resolve(response.data.data);
                        else
                            reject(response.data);
                    })
                        .catch(function (e) {
                        reject(e);
                    });
                }
                else {
                    reject({ vcode: 50, message: 'you are logged out' });
                }
            });
        });
    };
    /**
     * @description: Lấy về tất cả các cửa hàng (endusers) đã đăng ký vào hệ thống phần mềm, theo thời gian, theo nhân viên bán phần mềm cho khách, theo tình trạng cửa hàng
     * @example:
     * let starttime = new Date('2022-03-13T05:24:00');
     * let endtime = new Date();
     * this.queryVhAPP.getEndUsers_byTime_bySalesman_byStatusStore(starttime, endtime, 'JU9vVWaZlvXGwZgX6IvyJo8oEG12', 1, project)
           .then(result=>{
             console.log('result', result);
           }, error=>{
             console.log('error', error);
           })
     * @param starttime
     * @param endtime
     * @param id_salesman : 'all' or id_employeee = 'JU9vVWaZlvXGwZgX6IvyJo8oEG12'
     * @param status_store : 'all' or 1,2,3,4, or 5................
     * @param project : vhsales, vhcafe, bvhsales, bvhcafe
     * @returns Promise Array
     */
    QueryVhAPP.prototype.getEndUsers_byTime_bySalesman_byStatusStore = function (starttime, endtime, id_salesman, status_store, project) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var body = { starttime: starttime, endtime: endtime, id_salesman: id_salesman, status_store: status_store, project: project };
            _this.firebaseAuth.checkSignedIn()
                .then(function (bool) {
                if (bool) {
                    axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/getendusersappfromvhwebbytimebysalesmanbystatusstore', __assign({}, body))
                        .then(function (response) {
                        if (response.data.vcode === 0)
                            resolve(response.data.data);
                        else
                            reject(response.data);
                    })
                        .catch(function (e) {
                        reject(e);
                    });
                }
                else {
                    reject({ vcode: 50, message: 'you are logged out' });
                }
            });
        });
    };
    /**
     * hàm này sẽ bỏ thay băng hàm salesman hoặc carestaff
     * @description: Lấy về tất cả các cửa hàng (endusers) đã đăng ký vào hệ thống phần mềm, theo thời gian, theo nhân viên, theo tình trạng cửa hàng
     * @example:
     * let starttime = new Date('2022-03-13T05:24:00');
     * let endtime = new Date();
     * this.queryVhAPP.getEndUsers_byTime_byEmployee_byStatusStore(starttime, endtime, 'JU9vVWaZlvXGwZgX6IvyJo8oEG12', 1, project)
           .then(result=>{
             console.log('result', result);
           }, error=>{
             console.log('error', error);
           })
     * @param starttime
     * @param endtime
     * @param id_employee : 'all' or id_employeee = 'JU9vVWaZlvXGwZgX6IvyJo8oEG12'
     * @param status_store : 'all' or 1,2,3,4, or 5................
     * @param project : vhsales, vhcafe, bvhsales, bvhcafe
     * @returns Promise Array
     */
    QueryVhAPP.prototype.getEndUsers_byTime_byEmployee_byStatusStore = function (starttime, endtime, id_employee, status_store, project) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var body = { starttime: starttime, endtime: endtime, id_employee: id_employee, status_store: status_store, project: project };
            _this.firebaseAuth.checkSignedIn()
                .then(function (bool) {
                if (bool) {
                    axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/getendusersappfromvhwebbytimebyemployeebystatusstore', __assign({}, body))
                        .then(function (response) {
                        if (response.data.vcode === 0)
                            resolve(response.data.data);
                        else
                            reject(response.data);
                    })
                        .catch(function (e) {
                        reject(e);
                    });
                }
                else {
                    reject({ vcode: 50, message: 'you are logged out' });
                }
            });
        });
    };
    /**
    * @example:
    * this.queryVhAPP.updateEndUser_Employee(docKey, id_employee, 'project')
          .then(result=>{
            console.log('result', result);
          }, error=>{
            console.log('error', error);
          })
    * @param docKey
    * @param id_employee
    * @param project : vhsales, vhcafe, bvhsales, bvhcafe
    * @returns Promise => true or false
    */
    QueryVhAPP.prototype.updateEndUser_Employee = function (docKey, id_employee, project) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (id_employee == undefined)
                resolve(false);
            var body = { docKey: docKey, id_employee: id_employee, project: project };
            _this.firebaseAuth.checkSignedIn()
                .then(function (bool) {
                if (bool) {
                    axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/updateenduserappfromvhwebemployee', __assign({}, body))
                        .then(function (response) {
                        if (response.data.vcode === 0)
                            resolve(true);
                        else
                            resolve(false);
                    })
                        .catch(function (e) {
                        reject(e);
                    });
                }
                else
                    resolve(false);
            });
        });
    };
    /**
     * @example:
     * this.queryVhAPP.updateEndUser_Dealer('JU9vVWaZlvXGwZgX6IvyJo8oEG12', id_dealer, 'project')
           .then(result=>{
             console.log('result', result);
            }, error=>{
              console.log('error', error);
            })
      * @param docKey
      * @param id_dealer
      * @param project : vhsales, vhcafe, bvhsales, bvhcafe
      * @returns Promise => true or false
      */
    QueryVhAPP.prototype.updateEndUser_Dealer = function (docKey, id_dealer, project) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (id_dealer == undefined)
                resolve(false);
            var body = { docKey: docKey, id_dealer: id_dealer, project: project };
            _this.firebaseAuth.checkSignedIn()
                .then(function (bool) {
                if (bool) {
                    axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/updateenduserappfromvhwebdealer', __assign({}, body))
                        .then(function (response) {
                        if (response.data.vcode === 0)
                            resolve(true);
                        else
                            resolve(false);
                    })
                        .catch(function (e) {
                        reject(e);
                    });
                }
                else
                    resolve(false);
            });
        });
    };
    /**
     * @description: Hàm này nhân viên CSKH cập nhật lại tình trạng giao dịch giữa CSKH với enduser
     * @example:
     * this.queryVhAPP.updateEndUser_StatusStore('JU9vVWaZlvXGwZgX6IvyJo8oEG12', 1, project)
           .then(result=>{
             console.log('result', result);
            }, error=>{
              console.log('error', error);
            })
      * @param docKey
      * @param status_store
      * @param project : vhsales, vhcafe, bvhsales, bvhcafe
      * @returns Promise => true or false
      */
    QueryVhAPP.prototype.updateEndUser_StatusStore = function (docKey, status_store, project) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (status_store == undefined)
                resolve(false);
            var body = { docKey: docKey, status_store: status_store, project: project };
            _this.firebaseAuth.checkSignedIn()
                .then(function (bool) {
                if (bool) {
                    axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/updateenduserappfromvhwebstatusstore', __assign({}, body))
                        .then(function (response) {
                        if (response.data.vcode === 0)
                            resolve(true);
                        else
                            resolve(false);
                    })
                        .catch(function (e) {
                        reject(e);
                    });
                }
                else
                    resolve(false);
            });
        });
    };
    /**
     * Hàm này cập nhật partner nào là người bán phần mềm cho enduser
     * @example:
     * this.queryVhAPP.updateEndUser_Dealer('JU9vVWaZlvXGwZgX6IvyJo8oEG12', id_salesman, 'project')
           .then(result=>{
             console.log('result', result);
            }, error=>{
              console.log('error', error);
            })
      * @param docKey
      * @param id_salesman null or string
      * @param project : vhsales, vhcafe, bvhsales, bvhcafe
      * @returns Promise => true or false
      */
    QueryVhAPP.prototype.updateEndUser_Salesman = function (docKey, id_salesman, project) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (id_salesman == undefined)
                resolve(false);
            var body = { docKey: docKey, id_salesman: id_salesman, project: project };
            _this.firebaseAuth.checkSignedIn()
                .then(function (bool) {
                if (bool) {
                    axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/updateenduserappfromvhwebsalesman', __assign({}, body))
                        .then(function (response) {
                        if (response.data.vcode === 0)
                            resolve(true);
                        else
                            resolve(false);
                    })
                        .catch(function (e) {
                        reject(e);
                    });
                }
                else
                    resolve(false);
            });
        });
    };
    /**
     * Hàm này cập nhật partner nào là người cskh
     * @example:
     * this.queryVhAPP.updateEndUser_CareStaff('JU9vVWaZlvXGwZgX6IvyJo8oEG12', id_customer_care, 'project')
           .then(result=>{
             console.log('result', result);
            }, error=>{
              console.log('error', error);
            })
      * @param docKey
      * @param id_carestaff null or string
      * @param project : vhsales, vhcafe, bvhsales, bvhcafe
      * @returns Promise => true or false
      */
    QueryVhAPP.prototype.updateEndUser_CareStaff = function (docKey, id_carestaff, project) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (id_carestaff == undefined)
                resolve(false);
            var body = { docKey: docKey, id_carestaff: id_carestaff, project: project };
            _this.firebaseAuth.checkSignedIn()
                .then(function (bool) {
                if (bool) {
                    axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/updateenduserappfromvhwebcarestaff', __assign({}, body))
                        .then(function (response) {
                        if (response.data.vcode === 0)
                            resolve(true);
                        else
                            resolve(false);
                    })
                        .catch(function (e) {
                        reject(e);
                    });
                }
                else
                    resolve(false);
            });
        });
    };
    /**
     * Hàm này tạo thêm chi nhánh cho Enduser; khách cung cấp email hoặc số điện thoại ==> lấy về được id_enduser ==> mở thêm chi nhánh cho khách
     * @description: Lấy về cửa hàng (enduser) đã đăng ký vào hệ thống phần mềm theo email
     * @example:
     * let data = {
          name: "Chi nhánh 2",
          date: new Date(),
          activate: true,
          address: "HCM",
          countrycode: "+84",
          phone: "978635247"
      }
      this.queryVhAPP.addEndUserBranch('1RSMPzgMSpM0tvMrRPeHvb7QavY2', data, 'vhsales')
           .then(result=>{
             console.log('result', result);
           }, error=>{
             console.log('error', error);
           })
     * @param email
     * @param project : vhsales, vhcafe, bvhsales, bvhcafe
     * @returns Promise Array
     */
    QueryVhAPP.prototype.addEndUserBranch = function (id_enduser, data, project) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var body = { id_enduser: id_enduser, data: data, project: project };
            _this.firebaseAuth.checkSignedIn() //kiểm tra đã đăng nhập admin của website viethas chưa
                .then(function (bool) {
                if (bool) {
                    data._id = 'xVLimqyZQgs2JmiHUvGg';
                    resolve({ vcode: 0, message: 'success', data: data });
                    /*axios.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/addenduserbranchappfromvhwebbyidenduser', {...body})
                          .then((response:any)=> {
                              if(response.data.vcode === 0) resolve(response.data.data);
                              else reject(response.data);
                          })
                          .catch((e:any)=> {
                            reject(e);
                          }); */
                }
                else {
                    reject({ vcode: 50, message: 'you are logged out' });
                }
            });
        });
    };
    /**
     * Hàm này lấy về thông tin tất cả các chi nhánh của Enduser; khách cung cấp email hoặc số điện thoại ==> lấy về được id_enduser ==> lấy về tất cả các chi nhánh
     * @description: Lấy về cửa hàng (enduser) đã đăng ký vào hệ thống phần mềm theo email
     * @example:
     * this.queryVhAPP.getEndUserBranchs('1RSMPzgMSpM0tvMrRPeHvb7QavY2','vhsales')
           .then(result=>{
             console.log('result', result);
           }, error=>{
             console.log('error', error);
           })
     * @param id_enduser
     * @param project : vhsales, vhcafe, bvhsales, bvhcafe
     * @returns Promise Array
     */
    QueryVhAPP.prototype.getEndUserBranchs = function (id_enduser, project) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var body = { id_enduser: id_enduser, project: project };
            _this.firebaseAuth.checkSignedIn() //kiểm tra đã đăng nhập admin của website viethas chưa
                .then(function (bool) {
                if (bool) {
                    axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/getenduserbranchsappfromvhwebbyidenduser', __assign({}, body))
                        .then(function (response) {
                        if (response.data.vcode === 0)
                            resolve(response.data.data);
                        else
                            reject(response.data);
                    })
                        .catch(function (e) {
                        reject(e);
                    });
                }
                else {
                    reject({ vcode: 50, message: 'you are logged out' });
                }
            });
        });
    };
    /**
     * @description:  Hàm này lấy về thông tin tất cả các gói CHÍNH (giá phần mềm)
     * @example:
     * this.queryVhAPP.getEndUserMainPackages('vhsales')
           .then(result=>{
             console.log('result', result);
           }, error=>{
             console.log('error', error);
           })
     * @param project : vhsales, vhcafe, bvhsales, bvhcafe
     * @returns Promise Array
     */
    QueryVhAPP.prototype.getEndUserMainPackages = function (project) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var body = { project: project };
            _this.firebaseAuth.checkSignedIn() //kiểm tra đã đăng nhập admin của website viethas chưa
                .then(function (bool) {
                if (bool) {
                    axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/getendusermainpackagesappfromvhweb', __assign({}, body))
                        .then(function (response) {
                        if (response.data.vcode === 0)
                            resolve(response.data.data);
                        else
                            reject(response.data);
                    })
                        .catch(function (e) {
                        reject(e);
                    });
                }
                else {
                    reject({ vcode: 50, message: 'you are logged out' });
                }
            });
        });
    };
    /**
    * @description: lấy về nhật ký chăm sóc của một khách hàng
    * @example:
    * this.queryVhAPP.getCareDiarys('5fb67fda87c0f21d484cbdf3')
          .then((carediarys)=>{
            console.log('carediarys', carediarys);
          },error=>{
            console.log('error', error);
          })
    * @param id_store
    * @return Promise => obj ={} or null
    */
    QueryVhAPP.prototype.getCareDiarys = function (id_store) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('carediarys')
                .where('id_store', '==', id_store)
                .get()
                .then(function (json) {
                var array = new Array();
                json.docs.forEach(function (doc) {
                    array.push(_this.ordinaryAlgorithm.cvtDataFB2MG(doc.data()));
                    array[array.length - 1]._id = doc.id;
                });
                resolve(array);
            }, function (error) {
                reject(error);
            });
        });
    };
    /**
     * @description: Tạo mới nhật ký chăm sóc khách hàng
     * @example:
     * this.queryVhAPP.addCareDiary(value)
           .then(obj=>{
             console.log('obj', obj);
           }, error=>{
             console.log('error', error);
           })
     * @param starttime
     * @param endtime
     * @param value : {id_store, id_carestaff, date, content}
     * @returns Promise Array
     */
    QueryVhAPP.prototype.addCareDiary = function (value) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('carediarys')
                .add(value)
                .then(function (doc) {
                var obj = __assign({}, value);
                obj._id = doc.id;
                resolve(obj);
            })
                .catch(function (e) {
                console.log(e);
                reject(e);
            });
        });
    };
    /**
     * @description: Cập nhật nhật ký chăm sóc khách hàng
     * @example:
     *  this.queryVhAPP.updateCareDiary('5fb6780ca2148e09806c5b01', {content:'chào bạn'})
          .then(()=>{
            resolve();
          }, error=>{
            reject(error);
          })
      * @param id_carediary
      * @param value
      * @return Promise => bool = true or false
      */
    QueryVhAPP.prototype.updateCareDiary = function (id_carediary, value) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('carediarys')
                .doc(id_carediary)
                .update(value) //firebase trả về undefined, (đã check)
                .then(function () {
                resolve(true);
            })
                .catch(function (e) {
                console.log(e);
                resolve(false);
            });
        });
    };
    /**
   * @description: Xóa nhật ký chăm sóc khách hàng
   * @example:
   *  this.queryVhAPP.deleteCareDiary('5fb6780ca2148e09806c5b01')
        .then(()=>{
          resolve();
        }, error=>{
          reject(error);
        })
    * @param id_carediary
    * @return Promise => bool = true or false
    */
    QueryVhAPP.prototype.deleteCareDiary = function (id_carediary) {
        return new Promise(function (resolve, reject) {
            firebase.firestore()
                .collection('carediarys')
                .doc(id_carediary)
                .delete() //firebase trả về undefined, (đã check)
                .then(function () {
                resolve(true);
            })
                .catch(function (e) {
                console.log(e);
                resolve(false);
            });
        });
    };
    /**
    * Hàm này dùng để thực hiện đổi voucher lấy hàng hóa
    * @example
        //Truyền vào
        let payment = {
          id_partner: 'AEUWSWZXA4iHv8BmCNz2', //là người đăng nhập vào trang quản trị và tạo thanh toán này
          date: new Date(),
          payment: 990.000,
          tax: 0,
          total: 990.000
        }
        //Trả về
        _payment = {
            _id,
            date
            payment_code,
            id_store,
            invalid,
            
            payment_type,
            payment,
            tax,
            total
        }
        //Truyền vào
        let payment_details =[{payment_detail_main},{payment_detail_ecommerce},{payment_detail_facebook}, {payment_detail_warranty},{},...]
        let payment_detail_main = {
          id_branch: 'AEUWSWZXA4iHv8BmCNz2', //khách chọn
          id_restriction: 'main_package_advanced', //package.id_restriction
          id_package: 'main_package_advanced_1month', //có được khi khách chọn gói để mua
          package_type: 1,  //package.package_type,
          day: 31, //package.day,
          tax: 0, package.tax,
          price: 99000, package.price,
          quantity: 1, //khách chọn
          payment_detail_type: 1, //1: gói gia hạng mới, 2: gói nâng cấp, 3: gói kéo dài thêm thời gian
        }
        //Trả về
        _payment_detail_main = {
            _id,
            id_payment
            id_store,
            payment_type,
            activating,
            invalid,
            date,
          
            id_branch,
            id_restriction,
            id_package,
            package_type,
            payment_detail_type,
            day,
            tax,
            price,
            quantity
        }
        this.queryVhweb.createPayment_Paymentdetail(payment, bill_details, id_enduser, project)
            .then((payment:any)=>{
                console.log('payment', payment);
            },(error:any)=>{
                console.log('error ', error);
            })
    * @param payment
    * @param bill_details
    * @returns Promise => object = {} or null
    */
    QueryVhAPP.prototype.createPayment_Paymentdetail = function (payment, bill_details, id_enduser, project) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            //payment.date = new Date();//Ngày này cho nhân viên chọn đưa vào, lấy ngày hệ thống kiểm tra các trường gian dối có thể xảy ra
            payment.payment_type = 1;
            payment.payment_code = _this.ordinaryAlgorithm.createPaymentCode(payment === null || payment === void 0 ? void 0 : payment.date);
            var body_payment = {};
            axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/addenduserbranchappfromvhwebbyidenduser', __assign({}, body_payment))
                .then(function (response) {
                if (response.data.vcode === 0) {
                    var _payment_1 = response.data.data;
                    var promise = new Array();
                    for (var i = 0; i < bill_details.length; i++) {
                        var _payment_detail = bill_details[i];
                        //---------------NEW-----------------     
                        _payment_detail.id_payment = _payment_1._id;
                        _payment_detail.id_store = id_enduser;
                        _payment_detail.activating = false;
                        _payment_detail.invalid = false;
                        _payment_detail.date = _payment_1.date;
                        _payment_detail.payment_type = _payment_1.payment_type;
                        if (_payment_1.id_cashier)
                            _payment_detail.id_cashier = _payment_1.id_cashier;
                        if (_payment_1.id_partner)
                            _payment_detail.id_partner = _payment_1.id_partner;
                        var body_payment_detail = {};
                        //promise[i] = this.vhmongo_firebase.database().addDoc('vhbill_details', data);         
                        axios_1.default.post('https://us-central1-servers-1b3fe.cloudfunctions.net/app' + '/usermanagement/addenduserbranchappfromvhwebbyidenduser', __assign({}, body_payment_detail))
                            .then(function (response) {
                            if (response.data.vcode === 0) {
                            }
                        });
                    }
                    Promise.all(promise)
                        .then(function () {
                        resolve(_payment_1);
                    });
                }
                else
                    reject(response.data);
            })
                .catch(function (e) {
                reject(e);
            });
        });
    };
    QueryVhAPP = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [FirebaseStorage,
            FirebaseAuth,
            OrdinaryQuery,
            OrdinaryComponent,
            OrdinaryAlgorithm])
    ], QueryVhAPP);
    return QueryVhAPP;
}());
exports.QueryVhAPP = QueryVhAPP;
//# sourceMappingURL=index.js.map